/* Български — Bulgarian */
const bg = {
  nav: {
    home: 'Начало',
    imageConverter: 'Конвертор на Изображения',
    imageCompressor: 'Компресор на Изображения',
    otherTools: 'Други Инструменти',
    resizeImage: 'Промяна на Размера',
    cropImage: 'Изрязване на Изображение',
    photoEditor: 'Фоторедактор',
    removeBackground: 'Премахване на Фон',
    watermarkImage: 'Воден Знак',
    qrCodeGenerator: 'Генератор на QR Кодове',
    qrCodeScanner: 'Скенер на QR Кодове',
    aboutUs: 'За Нас',
    faceBlur: 'Замъгляване на Лице',
  },

  hero: {
    heading: 'Всички Инструменти за Изображения, от Които Се Нуждаете',
    subheading: 'Безплатни онлайн инструменти за конвертиране, компресиране, промяна на размер, изрязване и редактиране на изображения. Цялата обработка се извършва в браузъра — бързо и сигурно.',
  },

  tools: {
    compressImage: { title: 'Компресиране на Изображение', desc: 'Компресирайте JPG, PNG, SVG и GIF, запазвайки качеството.' },
    resizeImage: { title: 'Промяна на Размера', desc: 'Промяна на размера в проценти или пиксели.' },
    cropImage: { title: 'Изрязване на Изображение', desc: 'Лесно изрязвайте JPG, PNG и GIF.' },
    convertToJpg: { title: 'Конвертиране към JPG', desc: 'Пакетно конвертирайте PNG, GIF, TIF, SVG, WEBP и др. към JPG.' },
    convertFromJpg: { title: 'Конвертиране от JPG', desc: 'Конвертирайте JPG изображения към PNG и GIF.' },
    qrCodeGenerator: { title: 'Генератор на QR Кодове', desc: 'Създавайте персонализирани QR кодове за URL, текст, WiFi, контакти и др.' },
    qrCodeScanner: { title: 'Скенер на QR Кодове', desc: 'Незабавно сканирайте QR кодове с камера или качете изображение.' },
    blurFace: { title: 'Замъгляване на Лице', desc: 'Автоматично откривайте и замъглявайте лица за защита на поверителността.' },
    removeBackground: { title: 'Премахване на Фон', desc: 'Бързо премахвайте фона на изображения с висока точност.' },
    watermarkImage: { title: 'Воден Знак', desc: 'Добавяйте водни знаци към изображения за секунди.' },
  },

  whyChoose: {
    label: 'Защо Ние',
    heading: 'По-Умен Начин за Редактиране на Изображения',
    subheading: 'Доверен от хиляди творци, дизайнери и разработчици по целия свят.',
    reasons: {
      fast: { title: 'Светкавично Бърз', desc: 'Цялата обработка се извършва директно в браузъра ви. Без качване на външни сървъри.' },
      private: { title: '100% Сигурен и Поверителен', desc: 'Файловете ви никога не напускат устройството. Ние не съхраняваме изображенията ви.' },
      noLimits: { title: 'Без Ограничения, Без Регистрация', desc: 'Използвайте всички инструменти колкото искате — напълно безплатно.' },
      quality: { title: 'Професионално Качество', desc: 'Нашите алгоритми осигуряват резултати на професионално ниво.' },
      batch: { title: 'Пакетна Обработка', desc: 'Обработвайте множество файлове едновременно.' },
      everywhere: { title: 'Работи Навсякъде', desc: 'Работи перфектно на компютър, таблет и телефон.' },
    },
    stats: {
      imagesProcessed: 'Обработени Изображения',
      countriesServed: 'Обслужвани Страни',
      uptime: 'Работно Време',
      freeTools: 'Безплатни Инструменти',
    },
  },

  footer: {
    tagline: 'Безплатни онлайн инструменти за изображения — конвертирайте, компресирайте, променяйте размера, изрязвайте и редактирайте изображения за секунди.',
    imageTools: 'Инструменти за Изображения',
    moreTools: 'Още Инструменти',
    company: 'Компания',
    contact: 'Контакт',
    allRightsReserved: 'Всички права запазени.',
    privacyPolicy: 'Политика за Поверителност',
    termsOfService: 'Условия за Ползване',
  },

  faq: {
    badge: 'ЧЗВ',
    heading: 'Често Задавани Въпроси',
    subheading: 'Бързи отговори на общи въпроси относно тези инструменти.',
    stillHaveQuestions: 'Имате още въпроси? С удоволствие ще помогнем!',
    reachOut: 'Свържете се с Нас',
    questionHeader: 'Въпрос',
  },

  contactForm: {
    badge: 'Свъжете се',
    title: 'Свъжете се с нас',
    subtitle: 'Ще се радваме да чуем от вас. Изпратете ни съобщение!',
    nameLabel: 'Име',
    namePlaceholder: 'Вашето пълно име',
    emailLabel: 'Имейл',
    emailPlaceholder: 'vie@email.bg',
    subjectLabel: 'Тема',
    subjectPlaceholder: 'За какво става дума?',
    messageLabel: 'Съобщение',
    messagePlaceholder: 'Напишете съобщението си тук…',
    errName: 'Името е задължително',
    errEmail: 'Имейлът е задължителен',
    errEmailInvalid: 'Въведете валиден имейл',
    errSubject: 'Темата е задължителна',
    errMessage: 'Съобщението е задължително',
    sending: 'Изпращане…',
    send: 'Изпрати съобщение',
    successTitle: 'Съобщението е изпратено!',
    successMsg: 'Благодарим ви за контакта. Ще ви отговорим скоро.',
    sendAnother: 'Изпрати още',
    sendError: 'Нещо се обърка. Моля, опитайте отново.',
  },

  about: {
    label: 'За Нас',
    heading: 'Създадено за Творци, от Творци',
    subheading: 'Вярваме, че мощните инструменти за изображения трябва да бъдат безплатни, бързи и достъпни за всички.',
    missionTitle: 'Нашата Мисия',
    missionText: 'photremium.com е създаден с единствената цел: да осигури най-интуитивното, бързото и поверително изживяване при редактиране на изображения в мрежата.',
    privacyTitle: 'Поверителността на Първо Място',
    privacyText: 'Ние не качваме, не съхраняваме и не обработваме дистанционно изображенията ви. Всичко остава на устройството ви.',
    techTitle: 'Съвременни Технологии',
    techText: 'Изградено с най-новите уеб технологии, включително WebAssembly, Canvas API и модерен React.',
    communityTitle: 'Ориентирано към Общността',
    communityText: 'Всяка функция е вдъхновена от обратната връзка от реални потребители.',
    globalTitle: 'Глобален Обхват',
    globalText: 'Използван от творци от над 120 страни.',
  },

  seo: {
    homeTitle: 'photremium.com — Безплатен Онлайн Конвертор, Компресор и Редактор на Изображения',
    homeDesc: 'Конвертирайте, компресирайте, променяйте размера, изрязвайте и редактирайте изображения безплатно онлайн.',
    homeKeywords: 'конвертор на изображения, компресор на изображения, промяна на размера, изрязване, фоторедактор',
    aboutTitle: 'За photremium.com — Нашата Мисия',
    aboutDesc: 'Научете за photremium.com, безплатния онлайн пакет инструменти за изображения, на когото се доверяват милиони.',
    aboutKeywords: 'за photremium.com, инструменти за изображения, безплатен редактор на изображения',
  },

      privacyPolicyPage: {
    seo: {
      title: 'Политика за поверителност — Photremium | Без качване на сървър, нулево съхранение на данни',
      description: 'Политиката за поверителност на Photremium обяснява как защитаваме вашата поверителност. Цялата обработка на изображения се извършва 100% във вашия браузър — без качване на файлове на сървър, без събиране на лични данни, без проследяване.',
      ogTitle: 'Политика за поверителност — Photremium | Без качвания, нулево място за съхранение',
      ogDescription: 'Вашите файлове остават на вашето устройство. Photremium обработва всички изображения локално във вашия браузър без контакт със сървъра, без съхраняване на данни и без проследяване.',
      twitterTitle: 'Политика за поверителност — Photremium',
      twitterDescription: '100% базирани на браузър инструменти за изображения. Без качвания, без съхранение, без проследяване. Прочетете пълната ни политика за поверителност.',
      schemaName: 'Политика за поверителност - Photremium',
      schemaDescription: 'Политика за поверителност на Photremium - без качване на сървъри, без съхраняване на данни, 100% обработка на изображения в браузъра.'
    },
    hero: {
      badge: 'Политика за поверителност',
      titlePrefix: 'Вашата поверителност е наша',
      titleHighlight: 'Най-висок приоритет',
      subPrefix: 'photremium.com е изграден на прост принцип —',
      subStrong: 'вашите файлове никога не напускат вашето устройство',
      subSuffix: 'Всеки инструмент за изображения на този сайт работи изцяло във вашия браузър. Няма качвания. Без облак. Без компромис.',
      effectiveLabel: 'Ефективен',
      lastUpdatedLabel: 'Последна актуализация',
      worldwideLabel: 'Прилага се в цял свят'
    },
    trustCards: [
      {
        title: 'Няма качвания на сървъра',
        desc: 'Вашите файлове никога не напускат вашето устройство. Цялата обработка е 100% в браузъра.'
      },
      {
        title: 'Нулево съхранение на данни',
        desc: 'Ние не съхраняваме нищо за вас, вашите изображения или вашата дейност.'
      },
      {
        title: 'Без проследяване',
        desc: 'Без проследяване на поведението, без пръстови отпечатъци, без профилиране.'
      },
      {
        title: 'Съобразен с GDPR',
        desc: 'Проектиран от самото начало, за да спазва глобалните разпоредби за поверителност.'
      }
    ],
    contentsTitle: 'Съдържание',
    toc: {
      overview: 'Преглед',
      'no-upload': 'Без сървърна обработка',
      'data-collect': 'Данни, които събираме',
      cookies: 'Бисквитки и съхранение',
      'third-party': 'Услуги на трети страни',
      analytics: 'Анализ',
      children: 'Поверителност на децата',
      rights: 'Вашите права',
      security: 'сигурност',
      changes: 'Промени в политиката',
      contact: 'Свържете се с нас'
    },
    sections: {
      overview: {
        title: '1. Преглед',
        subtitle: 'Какво покрива тази политика',
        p1Prefix: 'Тази Политика за поверителност описва как',
        p1Middle: '("ние", "нас" или "наши") дръжки - или по-точно,',
        p1Italic: 'не се справя',
        p1Suffix: 'вашата лична информация, когато използвате нашите безплатни онлайн инструменти за изображения на адрес',
        p2: 'За разлика от традиционните уеб приложения, които изпращат файлове до отдалечени сървъри за обработка, photremium.com използва съвременни API на браузъра (API на Canvas, WebAssembly, WebWorkers), за да изпълнява всяка операция локално на вашето устройство. Резултатът: без предаване на данни, без съхранение, без риск.',
        calloutLabel: 'Резюме на обикновен английски:',
        calloutText: 'Ние не можем да видим вашите изображения, ние не искаме, и нашата технология е специално проектирана така, че никога да не можем.'
      },
      noUpload: {
        title: '2. Без сървърна обработка — никога',
        subtitle: 'Как всъщност работят нашите инструменти',
        introPrefix: 'Всеки инструмент на photremium.com — конвертор на изображения, компресор, инструмент за преоразмеряване, премахване на фон, замъгляване на лице, воден знак, изрязване и инструменти за QR код — обработва вашите файлове',
        introStrong: '100% във вашия уеб браузър',
        introSuffix: 'използване на клиентски JavaScript и WebAssembly.',
        points: [
          {
            label: 'Никога не се случва качване на файл.',
            text: 'Когато изберете файл, той се чете от File API на вашия браузър и се обработва в паметта — никога не се изпраща по мрежата.'
          },
          {
            label: 'Никой сървър не получава вашето изображение.',
            text: 'Нашият CDN обслужва само HTML, CSS и JavaScript активите, необходими за стартиране на приложението — не и вашите файлове.'
          },
          {
            label: 'Без временно съхранение.',
            text: 'Обработените резултати съществуват само в паметта на вашия браузър и се освобождават, когато затворите или излезете от страницата.'
          },
          {
            label: 'Работи офлайн.',
            text: 'Повечето инструменти продължават да функционират без интернет връзка след първоначалното зареждане на страницата — още едно доказателство, че не е включен сървър.'
          }
        ],
        callout: 'Можете да проверите това сами: отворете раздела Мрежа на браузъра си в Инструменти за разработчици, изберете изображение и потвърдете, че никакви файлови данни не се предават на външен сървър.'
      },
      dataCollect: {
        title: '3. Данни, които събираме (и не събираме)',
        subtitle: 'Пълна прозрачност на практиките за данни',
        headers: {
          type: 'Тип данни',
          collected: 'Събрани?',
          whereWhy: 'Къде / Защо'
        },
        rows: [
          {
            type: 'Вашите изображения / файлове',
            badge: 'Никога',
            variant: 'зелено',
            showX: true,
            whereWhy: 'Обработва се изцяло във вашия браузър — никога не се предава'
          },
          {
            type: 'Име / имейл адрес',
            badge: 'Никога',
            variant: 'зелено',
            showX: true,
            whereWhy: 'Не е необходим акаунт или регистрация, за да използвате който и да е инструмент'
          },
          {
            type: 'IP адрес',
            badge: 'Минимална',
            variant: 'сиво',
            showX: false,
            whereWhy: 'Стандартните регистрационни файлове на уеб сървъра се съхраняват <= 30 дни, не са свързани със самоличността'
          },
          {
            type: 'Тип браузър/ОС',
            badge: 'Минимална',
            variant: 'сиво',
            showX: false,
            whereWhy: 'Изпратено от вашия браузър автоматично; използва се само за съвместимост'
          },
          {
            type: 'Посетени страници / кликвания',
            badge: 'Обобщени',
            variant: 'синьо',
            showX: false,
            whereWhy: 'Само анонимен анализ (без лична идентификация)'
          },
          {
            type: 'Езикови предпочитания',
            badge: 'Само местно',
            variant: 'синьо',
            showX: false,
            whereWhy: 'Запазено в localStorage на вашето устройство — никога не ни е изпращано'
          },
          {
            type: 'Плащане / финансови данни',
            badge: 'Никога',
            variant: 'зелено',
            showX: true,
            whereWhy: 'photremium.com е напълно безплатен, без да се изискват плащания'
          }
        ]
      },
      cookies: {
        title: '4. Бисквитки и локално съхранение',
        subtitle: 'Какво се съхранява на вашето устройство',
        intro: 'photremium.com не използва рекламни бисквитки, нито бисквитки за проследяване на различни сайтове, нито бисквитки на трети страни. Единственото хранилище на браузъра, което използваме, е за основната функционалност на сайта.',
        points: [
          {
            label: 'Езикови предпочитания',
            text: 'Съхранява се в localStorage, така че сайтът да помни предпочитания от вас език между посещенията. Никога не е изпращано до нашите сървъри.'
          },
          {
            label: 'Предпочитания за тема / потребителски интерфейс',
            text: 'Ако зададете предпочитание за показване, то се запазва локално само на вашето устройство.'
          },
          {
            label: 'Няма сесийни бисквитки.',
            text: 'photremium.com няма система за влизане, така че никога не се записват бисквитки за идентификатор на сесия.'
          }
        ],
        callout: 'Можете да изчистите цялото локално хранилище на photremium.com по всяко време чрез настройките на вашия браузър (Настройки -> Поверителност -> Изчистване на данните за сърфирането -> Кеширани данни и бисквитки). Това няма ефект върху способността ви да използвате инструментите.'
      },
      thirdParty: {
        title: '5. Услуги на трети страни',
        subtitle: 'Външни услуги, които използваме и защо',
        intro: 'photremium.com използва минимален набор от доверени услуги на трети страни само за инфраструктура и производителност. Нито една от тези услуги не получава вашите изображения или каквато и да е лична информация.',
        headers: {
          service: 'Обслужване',
          purpose: 'Цел',
          dataShared: 'Споделени данни',
          privacyPolicy: 'Политика за поверителност'
        },
        rows: [
          {
            service: 'Страници на Cloudflare',
            purpose: 'Хостинг и CDN доставка на активи на сайта',
            dataShared: 'IP адрес, HTTP заглавки (стандартни)',
            privacyLink: 'https://www.cloudflare.com/privacypolicy/',
            privacyText: 'cloudflare.com/privacypolicy'
          },
          {
            service: 'Шрифт Awesome',
            purpose: 'Шрифтове за икони, заредени от CDN',
            dataShared: 'IP адрес (само CSS заявка)',
            privacyLink: 'https://fontawesome.com/privacy',
            privacyText: 'fontawesome.com/privacy'
          },
          {
            service: 'Google Fonts',
            purpose: 'Зареждане на шрифт (ако е приложимо)',
            dataShared: 'IP адрес (само заявка за шрифт)',
            privacyLink: 'https://policies.google.com/privacy',
            privacyText: 'policies.google.com'
          }
        ],
        outro: 'Ние не споделяме вашите данни с рекламодатели, брокери на данни или други трети страни извън доставчиците на инфраструктура, изброени по-горе.'
      },
      analytics: {
        title: '6. Анализ',
        subtitle: 'Обобщени, зачитащи поверителността данни за употреба',
        introPrefix: 'За да разберем кои инструменти са популярни и как да подобрим сайта, може да събираме',
        introStrong: 'обобщени, анонимизирани',
        introSuffix: 'статистика за употреба като:',
        points: [
          'Брой показвания на страници за инструмент (без идентификация на потребител)',
          'Източник на препоръка (напр. търсене в Google, директна връзка) — без лични данни',
          'Географски данни на ниво държава (не град или точно местоположение)',
          'Тип браузър/устройство за анализ на съвместимостта'
        ],
        calloutLabel: 'Никакви данни не са свързани с вас лично.',
        calloutText: 'Ние не използваме Google Analytics или Meta Pixel. Всички анализи, които използваме, са инструменти, които поставят на първо място поверителността (напр. правдоподобни или подобни).'
      },
      children: {
        title: '7. Поверителност на децата',
        subtitle: 'COPPA и съответствие с безопасността на децата',
        p1: 'photremium.com не събира съзнателно никаква лична информация от деца под 13 години (или 16 в Европейския съюз съгласно GDPR). Тъй като не събираме лични данни от нито един потребител, няма какво да правим специално за по-младите потребители — сайтът е еднакво безопасен за всички.',
        p2Prefix: 'Ако смятате, че дете по някакъв начин е изпратило лична информация чрез нашата форма за контакт, моля, свържете се незабавно с нас на',
        p2Suffix: 'и ние незабавно ще го изтрием.'
      },
      rights: {
        title: '8. Вашите права',
        subtitle: 'GDPR, CCPA и глобални права за поверителност',
        intro: 'Тъй като photremium.com не събира лична информация, повечето права на субектите на данни се прилагат тривиално — няма данни за вас, които да имате достъп, коригиране или изтриване. Въпреки това, ние напълно признаваме и уважаваме следните права:',
        points: [
          {
            label: 'Право на достъп',
            text: 'Можете да поискате копие от всички данни, които съхраняваме за вас. (Няма нищо освен анонимизирани регистрационни файлове.)'
          },
          {
            label: 'Право на корекция',
            text: 'Можете да поискате коригиране на неточни лични данни.'
          },
          {
            label: 'Право на изтриване („Право да бъдеш забравен“)',
            text: 'Можете да поискате изтриване на всички лични данни, които съхраняваме (член 17 от GDPR, CCPA).'
          },
          {
            label: 'Право на възражение/отказ',
            text: 'Можете да се откажете от всяко бъдещо събиране на анализи, като използвате инструмент за отказване на ниво браузър или блокиране на реклами.'
          },
          {
            label: 'Право на преносимост на данните',
            text: 'Цялата ви работа се изтегля директно на вашето устройство — не е необходима заявка за експортиране.'
          }
        ],
        callout: 'Тези права се прилагат за всички потребители по целия свят, независимо от юрисдикцията — ние прилагаме най-високия стандарт (GDPR) като наша основа.'
      },
      security: {
        title: '9. Сигурност',
        subtitle: 'Как защитаваме вашето преживяване',
        intro: 'Най-сигурните данни са тези, които никога не се събират. клиентската архитектура на photremium.com означава, че пробив в сървъра не може да разкрие вашите файлове, защото вашите файлове никога не са на нашите сървъри. Допълнителните мерки за сигурност включват:',
        points: [
          {
            label: 'Налагане на HTTPS',
            text: 'Целият трафик между вашия браузър и нашия CDN е криптиран чрез TLS 1.2+ с HSTS.'
          },
          {
            label: 'Правила за сигурност на съдържанието (CSP)',
            text: 'Строгите заглавки предотвратяват скриптове между сайтове и инжектиране на вградени скриптове.'
          },
          {
            label: 'Редовни одити на зависимости',
            text: 'Ние проверяваме и актуализираме редовно npm пакетите, за да коригираме известни уязвимости.'
          }
        ],
        disclosurePrefix: 'Отговорно разкриване',
        disclosureTextPrefix: 'Открихте проблем със сигурността? Изпратете ни имейл на',
        disclosureTextSuffix: 'и ние ще отговорим в рамките на 48 часа.'
      },
      changes: {
        title: '10. Промени в тази Политика',
        subtitle: 'Как обработваме актуализациите на правилата',
        intro: 'Може да актуализираме тази Политика за поверителност от време на време, за да отразим промените в нашите практики, инструменти или законови изисквания. Когато правим:',
        points: [
          {
            label: '„Последна актуализация“',
            text: 'датата в горната част на тази страница ще бъде преработена.'
          },
          {
            label: 'Материални промени',
            text: 'ще бъде съобщено чрез видно известие на началната страница за най-малко 30 дни.'
          },
          {
            label: 'Предишни версии',
            text: 'от тази политика ще бъдат архивирани и достъпни при поискване.'
          }
        ],
        outro: 'Продължаващото използване на photremium.com след публикуване на промените означава приемане на актуализираната политика. Препоръчваме ви периодично да преглеждате тази страница.'
      },
      contact: {
        title: '11. Заявки за контакт и данни',
        subtitle: 'Свържете се относно поверителност',
        p1Prefix: 'За всякакви въпроси, притеснения или официални искания за данни, свързани с тази Политика за поверителност, моля, свържете се с нас. Ние се стремим да отговаряме на всички запитвания, свързани с поверителността в рамките на',
        p1Strong: '5 работни дни'
      }
    },
    footer: {
      privacyQuestionsTitle: 'Въпроси за поверителност?',
      privacyQuestionsDesc: 'Изпратете ни вашите въпроси относно поверителността, заявки за данни или притеснения и ние ще ви отговорим незабавно.',
      versionHistoryTitle: 'История на версиите',
      v2Label: 'v2.0 — Major rewrite',
      v11Label: 'v1.1 — Added CCPA rights',
      v10Label: 'v1.0 — Initial policy'
    }
  },
common: {
    new: 'Ново!',
    download: 'Изтегли',
    downloadAll: 'Изтегли Всички',
    downloadAs: 'Изтегли като:',
    zip: 'ZIP',
    separate: 'Поотделно',
    upload: 'Качи',
    dragDrop: 'Плъзнете и пуснете изображения тук или кликнете за разглеждане',
    remove: 'Премахни',
    reset: 'Нулиране',
    apply: 'Приложи',
    cancel: 'Отказ',
    clear: 'Изчисти',
    close: 'Затвори',
    save: 'Запази',
    processing: 'Обработване...',
    noFiles: 'Няма избран файл',
    selectFiles: 'Избери Файлове',
    or: 'или',
    browseFiles: 'Разгледай Файлове',
    dropHere: 'Пуснете изображения тук',
    chooseFiles: 'Избери Файлове',
    pasteHint: 'Можете също да поставите изображение',
    quality: 'Качество',
    width: 'Ширина',
    height: 'Височина',
    format: 'Формат',
    compression: 'Компресия',
    preview: 'Преглед',
    original: 'Оригинал',
    result: 'Резултат',
    before: 'Преди',
    after: 'След',
    startOver: 'Започни Отначало',
    startOverConfirm: 'Изтрий всички изображения и започни отначало?',
    addMoreImages: 'Добави Още Изображения',
    addImage: 'Добави Изображение',
    images: 'изображения',
    totalSize: 'Общ Размер',
    size: 'Размер',
    type: 'Тип',
    unsavedEdits: 'Имате незапазени промени. Напуснете тази страница?',
    compareSlider: 'Плъзгач за Сравнение',
    toggleToolsPanel: 'Превключи Панела с Инструменти',
    closePanel: 'Затвори Панела',
    zoomIn: 'Увеличи',
    zoomOut: 'Намали',
    fit: 'Побери',
    none: 'Няма',
  },

  compressor: {
    seo: {
      uploadTitle: 'Компресор на Изображения — Компресирайте JPG, PNG, SVG, GIF Безплатно | photremium.com',
      uploadDesc: 'Компресирайте JPG, PNG, SVG и GIF изображения безплатно онлайн. Намалете размера на файла до 80%, запазвайки качеството.',
      uploadKeywords: 'компресор на изображения, компресиране jpg, компресиране png, намаляване размера на изображение',
      workspaceTitle: 'Компресиране на Изображения — photremium.com',
      workspaceDesc: 'Настройте нивото на компресия и изтеглете оптимизирани изображения.',
      workspaceKeywords: 'компресиране на изображения, оптимизиране на изображения',
    },
    title: 'Компресор на Изображения',
    desc: 'Компресирайте JPG, PNG и GIF изображения до 80%. Бързо и сигурно.',
    toCompress: 'за компресиране',
    compressionForAll: 'Компресия за всички изображения',
    summary: 'Обобщение',
    originalSize: 'Оригинален Размер',
    compressed: 'Компресирано',
    saved: 'Спестено',
    compressionLabel: 'Компресия:',
    compressing: 'Компресиране…',
    compressDownload: 'Компресирай и Изтегли',
    lowQualityWarning: 'Високата компресия може осезаемо да намали яснотата на изображението.',
    blog: {
      tocTitle: 'Съдържание',
      title: 'Блог за компресиране на изображения',
      formatsIntro: 'Нашият инструмент поддържа всички формати на изображения, така че можете безпроблемно да компресирате всяко изображение. Пълният списък с формати е по-долу:',
      sections: [
        {
          id: 'imgcomp-card-1',
          title: '1. Какво е компресор на изображения?',
          paragraphs: [
            'Компресорът на изображения е софтуер или онлайн услуга, която намалява размера на файла на изображението, като запазва визуалното качество. Ако обаче компресирате прекалено много, качеството може да спадне осезаемо.',
          ],
          listTitle: 'ТИПОВЕ:',
          bullets: [
            'Компресия със загуба: размерът се намалява чрез премахване на част от данните на изображението. Качеството може леко да се понижи, но често това не се забелязва с просто око.',
            'Компресия без загуба: размерът на файла се намалява без влошаване на визуалното качество.',
          ],
        },
        {
          id: 'imgcomp-card-2',
          title: '2. Защо да изберете нашия инструмент?',
          bullets: [
            'Нашият AI компресор работи гладко на всички устройства и дава възможно най-добри резултати.',
            'Можете да компресирате много изображения наведнъж (дори 100+) само с един клик.',
            'Не е нужно да качвате изображенията на сървър — всичко се обработва локално в браузъра ви.',
            'Инструментът е напълно безплатен завинаги и можете да го споделяте с приятели.',
            'Можете сами да изберете процента на компресия според нуждите си.',
          ],
        },
        {
          id: 'imgcomp-card-3',
          title: '3. Ръководство стъпка по стъпка',
          steps: [
            {
              heading: '1. Изберете изображението/изображенията, които искате да компресирате.',
              bullets: [
                'Плъзнете и пуснете изображението/изображенията в полето за качване.',
                'Можете и да копирате изображенията и да ги поставите с (Ctrl + V).',
                'Поддържа се и файловият мениджър чрез бутона за избор.',
              ],
            },
            {
              heading: '2. След това изберете процент на компресия.',
              bullets: [
                'Хоризонталният плъзгач позволява удобно задаване на процента. Следвайте диапазоните по-долу за най-добри резултати.',
              ],
              table: {
                headers: ['Процент на компресия', 'Резултат'],
                rows: [
                  ['1%  до  40%', 'Най-добро качество'],
                  ['41%  до  60%', 'Нормално качество (Препоръчително)'],
                  ['61%  до  100%', 'Ниско качество'],
                ],
              },
            },
            {
              heading: '3. Проверете колко място сте спестили.',
              paragraphs: [
                'Всички показатели за размер се показват в реално време. Така ясно виждате колко място е спестено и можете да настроите компресията според нужния размер.',
              ],
            },
            {
              heading: '4. Изберете опция за изтегляне от бутона за превключване.',
              bullets: [
                'ZIP: ако компресирате няколко изображения, ще видите тази опция. Тя архивира всички компресирани изображения в един ZIP файл (препоръчително за много изображения).',
                'Отделно: всяко изображение ще се изтегли поотделно, а не в един ZIP файл (препоръчително за малък брой, под 10).',
              ],
            },
            {
              heading: '5. Компресирайте и изтеглете изображението.',
              paragraphs: [
                'Този бутон автоматично ще изтегли всички компресирани изображения според избраната опция за изтегляне.',
              ],
            },
          ],
        },
        {
          id: 'imgcomp-card-4',
          title: '4. Ползи от компресора на изображения.',
          bullets: [
            'Намалява разходите за съхранение: по-малките файлове заемат по-малко място.',
            'По-бързо зареждане: компресираните изображения се зареждат по-бързо и подобряват потребителското изживяване.',
            'Решение за ограничението на Gmail: при лимит 25MB компресията позволява да прикачите повече файлове.',
            'По-бързо споделяне и прехвърляне: големите файлове се изпращат по-бавно, а компресията спестява време и трафик.',
            'Оптимизация на презентации: некомпресираните изображения правят файловете тежки, докато компресираните значително намаляват размера.',
          ],
        },
        {
          id: 'imgcomp-card-5',
          title: '5. Поддържани формати.',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  converter: {
    seo: {
      uploadTitle: 'Конвертор на Изображения — Конвертирайте PNG, JPG, WEBP, GIF, SVG Безплатно | photremium.com',
      uploadDesc: 'Конвертирайте изображения между JPG, PNG, WEBP, GIF, SVG, TIFF и BMP. Безплатен онлайн конвертор на формати.',
      uploadKeywords: 'конвертор на изображения, png към jpg, jpg към png, конвертор webp',
      workspaceKeywords: 'конвертиране на изображения, конвертор на формати',

      routeKeywords: {

        'png-to-jpg': 'png за конвертиране jpg, png to jpg, конвертор на изображения, png към jpg, jpg към png, конвертор webp',

        'jpg-to-png': 'jpg за конвертиране png, jpg to png, конвертор на изображения, png към jpg, jpg към png, конвертор webp',

        'png-to-webp': 'png за конвертиране webp, png to webp, конвертор на изображения, png към jpg, jpg към png, конвертор webp',

        'jpg-to-webp': 'jpg за конвертиране webp, jpg to webp, конвертор на изображения, png към jpg, jpg към png, конвертор webp',

        'webp-to-jpg': 'webp за конвертиране jpg, webp to jpg, конвертор на изображения, png към jpg, jpg към png, конвертор webp',

        'webp-to-png': 'webp за конвертиране png, webp to png, конвертор на изображения, png към jpg, jpg към png, конвертор webp',

        'gif-to-jpg': 'gif за конвертиране jpg, gif to jpg, конвертор на изображения, png към jpg, jpg към png, конвертор webp',

        'gif-to-png': 'gif за конвертиране png, gif to png, конвертор на изображения, png към jpg, jpg към png, конвертор webp',

        'bmp-to-jpg': 'bmp за конвертиране jpg, bmp to jpg, конвертор на изображения, png към jpg, jpg към png, конвертор webp',

        'bmp-to-png': 'bmp за конвертиране png, bmp to png, конвертор на изображения, png към jpg, jpg към png, конвертор webp',

        'svg-to-png': 'svg за конвертиране png, svg to png, конвертор на изображения, png към jpg, jpg към png, конвертор webp',

        'svg-to-jpg': 'svg за конвертиране jpg, svg to jpg, конвертор на изображения, png към jpg, jpg към png, конвертор webp',

        'tiff-to-jpg': 'tiff за конвертиране jpg, tiff to jpg, конвертор на изображения, png към jpg, jpg към png, конвертор webp',

        'tiff-to-png': 'tiff за конвертиране png, tiff to png, конвертор на изображения, png към jpg, jpg към png, конвертор webp',

        'jpg-to-gif': 'jpg за конвертиране gif, jpg to gif, конвертор на изображения, png към jpg, jpg към png, конвертор webp',

        'png-to-gif': 'png за конвертиране gif, png to gif, конвертор на изображения, png към jpg, jpg към png, конвертор webp',

        'jpg-to-bmp': 'jpg за конвертиране bmp, jpg to bmp, конвертор на изображения, png към jpg, jpg към png, конвертор webp',

        'png-to-bmp': 'png за конвертиране bmp, png to bmp, конвертор на изображения, png към jpg, jpg към png, конвертор webp',

        'webp-to-gif': 'webp за конвертиране gif, webp to gif, конвертор на изображения, png към jpg, jpg към png, конвертор webp',

        'jpg-to-ico': 'jpg за конвертиране ico, jpg to ico, конвертор на изображения, png към jpg, jpg към png, конвертор webp',

        'png-to-ico': 'png за конвертиране ico, png to ico, конвертор на изображения, png към jpg, jpg към png, конвертор webp',

        'jpg-to-svg': 'jpg за конвертиране svg, jpg to svg, конвертор на изображения, png към jpg, jpg към png, конвертор webp',

        'png-to-svg': 'png за конвертиране svg, png to svg, конвертор на изображения, png към jpg, jpg към png, конвертор webp',

        'webp-to-svg': 'webp за конвертиране svg, webp to svg, конвертор на изображения, png към jpg, jpg към png, конвертор webp',

        'gif-to-svg': 'gif за конвертиране svg, gif to svg, конвертор на изображения, png към jpg, jpg към png, конвертор webp',

        'bmp-to-svg': 'bmp за конвертиране svg, bmp to svg, конвертор на изображения, png към jpg, jpg към png, конвертор webp',

        'tiff-to-svg': 'tiff за конвертиране svg, tiff to svg, конвертор на изображения, png към jpg, jpg към png, конвертор webp',

      },
    },
    title: 'Конвертор на Изображения',
    desc: 'Конвертирайте изображения между JPG, PNG, WEBP, GIF, SVG, TIFF и BMP. Пакетно конвертиране.',
    toConvert: 'за конвертиране',
    convertSettings: 'Настройки за Конвертиране',
    detected: 'Открито',
    convertTo: 'Конвертирай към',
    converting: 'Конвертиране…',
    convertToFormat: 'Конвертирай към {format}',
    popularConversions: 'Популярни Конвертирания',
    convertingTo: 'Конвертиране към',
    all: 'Всички',
  },

  resizer: {
    seo: {
      uploadTitle: 'Промяна на Размера на Изображение — JPG, PNG Безплатно | photremium.com',
      uploadDesc: 'Променяйте размера на изображения в пиксели или проценти безплатно онлайн.',
      uploadKeywords: 'промяна на размер на изображение, инструмент за размер, jpg размер, png размер',
      workspaceTitle: 'Промяна на Размера на Изображение — photremium.com',
      workspaceDesc: 'Променяйте размера на изображения безплатно онлайн.',
      workspaceKeywords: 'промяна на размер, преоразмеряване',
    },
    title: 'Промяна на Размера на Изображение',
    desc: 'Задайте размер в пиксели, проценти, сантиметри или инчове и незабавно променете размера.',
    toResize: 'за промяна на размера',
    resizeSettings: 'Настройки за Размер',
    resizeBy: 'Промени размера по:',
    byPixels: 'Пиксели',
    byPercentage: 'Проценти',
    byCentimeters: 'Сантиметри',
    byInches: 'Инчове',
    advanced: 'Разширени',
    lockAspect: 'Заключи Пропорциите',
    unlockAspect: 'Отключи Пропорциите',
    dontEnlarge: 'Не увеличавай, ако оригиналът е по-малък',
    resizing: 'Промяна на размера…',
    resizeDownload: 'Промени Размера и Изтегли',
    blog: {
      tocTitle: 'Съдържание',
      title: 'Блог за Преоразмеряване на Изображения',
      sections: [
        {
          id: 'imgresize-card-1',
          title: '1. Защо да използвате инструмент за преоразмеряване на изображения?',
          paragraphs: [
            'Инструментът за преоразмеряване на изображения е софтуер, който се използва за промяна на размерите на изображението. Той ви позволява да коригирате размера на желаното изображение чрез промяна на височината, ширината или и двете. Този инструмент е особено полезен за социални платформи, които имат ограничения за размерите при качване или публикуване на изображения.',
          ],
          listTitle: 'Например:',
          bullets: [
            'Публикации в Instagram: 1080 x 1080px (квадрат)',
            'Публикация във Facebook: 1200 x 630px',
            'Публикация в X (бивш Twitter): 1200 x 675px',
            'Instagram Story: 1080 x 1920px',
          ],
        },
        {
          id: 'imgresize-card-2',
          title: '2. Защо да изберете нашия инструмент за преоразмеряване на изображения?',
          paragraphs: [
            'Нашият AI инструмент за преоразмеряване прави процеса точен и изключително бърз. Можете да използвате този инструмент безпроблемно на всяко устройство. Няма нужда да инсталирате или изтегляте приложение. Всички услуги са налични онлайн в браузъра по ваш избор.',
          ],
          bullets: [
            'Можете да преоразмерявате множество изображения (дори 100+) наведнъж с нашия инструмент. Ако имате устройство с висока производителност, можете удобно да преоразмерите 400 до 500 изображения за секунди.',
            'Цялата обработка се извършва във вашия локален браузър. Не е нужно да качвате изображения на нашите сървъри. Вашите изображения никога не напускат устройството ви. Така можете да преоразмерявате личните си снимки без риск за поверителността.',
            'Поддържат се множество мерни единици за преоразмеряване.',
            'Можете да запазите оригиналното съотношение на страните дори след преоразмеряване, само като отметнете съответната опция.',
            'Ако преоразмерявате няколко изображения, имате избор да изтеглите резултата като отделни файлове или като ZIP файл.',
          ],
        },
        {
          id: 'imgresize-card-3',
          title: '3. Ръководство стъпка по стъпка',
          steps: [
            {
              heading: 'Първо изберете изображението или изображенията, които искате да преоразмерите. Имате няколко начина за избор.',
              bullets: [
                'Можете просто да плъзнете и пуснете изображенията, за да ги преоразмерите.',
                'Поддържа се и клавишната комбинация Ctrl + V за поставяне на изображение в полето за качване.',
                'Натискането на бутона “Choose Files” ще отвори файловия мениджър. Оттам също можете да изберете желаните изображения.',
              ],
            },
            {
              heading: 'След това имате опция да изберете една от мерните единици за преоразмеряване. В момента предлагаме:',
              bullets: ['Pixels', 'Percentage', 'Centimeters', 'Inches'],
            },
            {
              heading: 'След избор на единица, коригирайте височината и ширината, за да преоразмерите изображението. Можете също да заключите съотношението, като отметнете опцията.',
            },
            {
              heading: 'След това отметнете “Don’t enlarge if original is smaller”, ако не искате изображението да се увеличава над оригиналния размер.',
            },
            {
              heading: 'След това изберете опцията за изтегляне.',
              bullets: [
                'Изберете ZIP, ако преоразмерявате много изображения и искате да изтеглите всички като един zip файл.',
                'Или изберете “separate”, за да изтеглите всяко изображение поотделно.',
              ],
            },
            {
              heading: 'Накрая натиснете бутона “Resize & Download”, за да изтеглите изображенията според избраната опция.',
            },
          ],
        },
        {
          id: 'imgresize-card-4',
          title: '4. Ползи от инструмента за преоразмеряване: Най-значимата полза е правилното позициониране на изображенията в уеб страници и публикации в социални мрежи.',
          tocLabel: '4. Ползи от инструмента за преоразмеряване',
          bullets: [
            'Подобряване на UX: Правилният размер и коректното позициониране на изображенията значително подобряват потребителското изживяване. Поставянето на твърде големи или твърде малки изображения без корекция води до лош UX.',
            'Поддръжка за социални мрежи: Много социални приложения имат собствени ограничения за размерите на изображенията. Нашият инструмент ви помага да ги приведете към изискваните размери.',
            'Responsive дизайн: Ако сте разработчик и създавате responsive дизайн, трябва да преоразмерявате изображенията в различни размери за различни устройства.',
            'Най-добър избор: Вместо разтягане или изрязване, които могат да влошат пропорциите, инструментът за преоразмеряване е най-добрият вариант.',
          ],
        },
        {
          id: 'imgresize-card-5',
          title: '5. Поддържани формати: Нашият инструмент за преоразмеряване позволява да изберете изображение от всеки формат. Ето поддържаните формати:',
          tocLabel: '5. Поддържани формати',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  cropper: {
    seo: {
      uploadTitle: 'Изрязване на Изображение — JPG, PNG, GIF Безплатно | photremium.com',
      uploadDesc: 'Лесно изрязвайте JPG, PNG и GIF изображения безплатно онлайн.',
      uploadKeywords: 'изрязване на изображение, инструмент за изрязване, изрязване jpg, изрязване png',
      workspaceTitle: 'Изрязване на Изображение — photremium.com',
      workspaceDesc: 'Изрязвайте изображения безплатно онлайн.',
      workspaceKeywords: 'изрязване на изображение, изрязване',
    },
    title: 'Изрязване на Изображение',
    desc: 'Изрязвайте JPG, PNG, GIF и др. с визуален редактор. Предварително зададени или свободни пропорции.',
    toCrop: 'за изрязване',
    cropSettings: 'Настройки за Изрязване',
    widthPx: 'Ширина (px)',
    heightPx: 'Височина (px)',
    positionX: 'Позиция X (px)',
    positionY: 'Позиция Y (px)',
    cropTemplate: 'Шаблон за Изрязване',
    landscape: 'Хоризонтален',
    portrait: 'Вертикален',
    square: 'Квадрат',
    freeform: 'Свободен',
    cropping: 'Изрязване…',
    cropDownload: 'Изрежи и Изтегли',
    cropDownloadAll: 'Изрежи и Изтегли Всички',
    saveNext: 'Запази и Следващо',
    croppedNofTotal: 'Изрязано {n} от {total}.',
    downloadN: 'Изтегли {n}',
    blog: {
      tocTitle: 'Съдържание',
      title: 'Блог за Изрязване на Изображения',
      sections: [
        {
          id: 'imgcrop-card-1',
          title: '1. Защо да използвате инструмент за изрязване на изображения?',
          paragraphs: [
            'Инструментът за изрязване на изображения е софтуерен инструмент, използван за изрязване на изображение до желаната форма. Той се използва широко за запазване на нужната част от изображението и премахване на външните нежелани части за всякакви цели. Инструментът предоставя рамка за изрязване, която можете да настройвате на позицията, която искате да изрежете.',
          ],
          listTitle: 'Например:',
          bullets: [
            'Да изрежете себе си от групова снимка.',
            'Да изрежете името си от списък.',
            'Да изрежете лентата за напредък от цял екранен кадър.',
          ],
        },
        {
          id: 'imgcrop-card-2',
          title: '2. Защо да изберете нашия инструмент за изрязване на изображения?',
          paragraphs: [
            'Нашият инструмент за изрязване ви позволява да изрязвате изображения прецизно и много бързо. Нужно е само да коригирате размера на рамката за изрязване на позицията, която искате да отрежете от което и да е изображение. Поддържат се почти всички формати изображения при избиране на файл.',
          ],
          bullets: [
            'Можете да изрежете толкова изображения, колкото устройството ви поддържа. Ако имате устройство с висока производителност, можете дори да изрежете 100+ изображения едновременно без забавяне или други проблеми.',
            'Вашите изображения се обработват в локалния ви браузър. Не е нужно да качвате изображения на нашия сървър, така че нито едно изображение не напуска устройството ви. Можете да изрязвате лични изображения без риск за сигурността.',
            'Много инструменти показват грешка за невалиден формат. Нашият инструмент решава този проблем, като поддържа почти всички формати изображения.',
            'Ако изрязвате много изображения наведнъж, нашият инструмент ви позволява да изтеглите изрязаните изображения като ZIP или като отделни файлове според предпочитанията ви.',
          ],
        },
        {
          id: 'imgcrop-card-3',
          title: '3. Ръководство стъпка по стъпка',
          steps: [
            {
              heading: '1. Първо изберете изображението, което искате да изрежете. Нашият инструмент поддържа и избор на няколко изображения едновременно.',
              bullets: [
                'Плъзнете и пуснете изображенията в полето за качване, за да ги изрежете.',
                'Можете също да изберете изображения чрез файловия мениджър, като кликнете бутона choose files в полето за изрязване.',
                'Поддържа се и клавишната комбинация Ctrl + V за поставяне на изображения в полето за качване.',
              ],
            },
            {
              heading: '2. След това коригирайте размера и позицията на рамката за изрязване върху изображението.',
            },
            {
              heading: '3. Можете също да настроите рамката ръчно, като въведете височина, ширина, хоризонтална и вертикална позиция.',
            },
            {
              heading: '4. Можете да използвате и няколко готови шаблона:',
              bullets: [
                'Landscape(16:9)',
                'Portrait(9:16)',
                'Square(1:1)',
              ],
            },
            {
              heading: '5. След това трябва да изберете една от опциите за изтегляне.',
              bullets: [
                'ZIP: Изберете тази опция, ако изрязвате много изображения и искате да изтеглите всички изрязани изображения като един файл.',
                'Separate: Ако искате да изтеглите всички изрязани изображения поотделно, изберете тази опция от бутона за превключване.',
              ],
            },
            {
              heading: '6. След това натиснете бутона Crop & Download, за да изтеглите всички изрязани изображения според зададените от вас размери.',
            },
          ],
        },
        {
          id: 'imgcrop-card-4',
          title: '4. Ползи от изрязването на изображения: инструментът за изрязване предлага няколко ползи в дигиталния свят. Някои от тях са описани по-долу:',
          tocLabel: '4. Ползи от изрязването на изображения',
          bullets: [
            'Напасване на изображения в рамка: инструментът за изрязване ви помага да поставите изображението правилно в рамка. Тази рамка може да е на уеб страница или в социална платформа.',
            'Подобряване на UX: тъй като правилното позициониране на изображения подобрява потребителското изживяване, изрязването помага значително за UX.',
            'Премахване на нежелани граници: можете да премахнете ненужните краища от изображението, за да го прецизирате.',
            'Отделяне на желания обект: можете също да отделите себе си от групова снимка.',
            'Спестяване на място: изрязването спестява пространство, защото излишната част от изображението се премахва и остава само нужната част.',
            'Оптимизиране на презентации: ако нормална презентация с 10 неизрязани изображения заема около 30MB, същата презентация с изрязани изображения може да заема около 10MB.',
          ],
        },
        {
          id: 'imgcrop-card-5',
          title: '5. Поддържани формати:',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  photoEditor: {
    seo: {
      title: 'Онлайн Фоторедактор — Безплатно Редактиране с Текст, Ефекти, Рамки | photremium.com',
      desc: 'Редактирайте снимки онлайн безплатно — добавяйте текст, ефекти, рамки, стикери. Работи в браузъра.',
      keywords: 'фоторедактор, онлайн фоторедактор, редактиране на снимки онлайн безплатно',
    },
    title: 'Фоторедактор',
    desc: 'Украсете снимките си с текст, ефекти, рамки и стикери.',
    toEdit: 'за редактиране',
    textTypography: 'Текст и Типография',
    textTypographyDesc: 'Добавяйте текст с различни шрифтове, цветове, сенки и опции за позициониране.',
    filtersEffects: 'Филтри и Ефекти',
    filtersEffectsDesc: 'Прилагайте професионални филтри и регулирайте яркостта, контраста и наситеността.',
    framesStickers: 'Рамки и Стикери',
    framesStickersDesc: 'Избирайте красиви рамки и забавни стикери, за да украсите изображенията си.',
  },

  removeBg: {
    seo: {
      uploadTitle: 'Безплатно Премахване на Фон на Изображение | photremium.com',
      uploadDesc: 'Бързо премахвайте фона на изображения с висока точност. Безплатен онлайн инструмент.',
      uploadKeywords: 'премахване на фон, изтриване на фон, прозрачен фон',
      workspaceTitle: 'Премахване на Фон — photremium.com',
      workspaceDesc: 'Премахвайте фона на изображения безплатно онлайн.',
      workspaceKeywords: 'премахване на фон, прозрачен фон',
    },
    title: 'Премахване на Фон',
    desc: 'Незабавно премахвайте фона на изображения с усъвършенствано засичане на ръбове. 100% безплатно, работи в браузъра.',
    toRemoveBg: 'за премахване на фона',
    backgroundRemover: 'Инструмент за Премахване на Фон',
    processingProgress: 'Напредък на Обработката',
    processingNImages: 'Обработване на {n} изображения…',
    allNProcessed: 'Всички {n} изображения са обработени!',
    nOfTotalDone: '{n} / {total} завършено',
    fileName: 'Име на Файл',
    dimensions: 'Размери',
    status: 'Статус',
    statusDone: '✓ Завършено',
    statusProcessing: '⏳ Обработване',
    statusError: '✗ Грешка',
    statusPending: '⏸ Изчакване',
    badgeDone: 'Завършено',
    badgeProcessing: 'Обработване…',
    badgeError: 'Грешка',
    removingBg: 'Премахване на фона…',
    retry: 'Опитай отново',
    downloading: 'Изтегляне…',
    nextImage: 'Следващо Изображение',
  },

  watermark: {
    seo: {
      uploadTitle: 'Воден Знак на Изображение — Добавете Текст и Лого Безплатно | photremium.com',
      uploadDesc: 'Добавяйте текстови или графични водни знаци към снимки за секунди. Безплатно, бързо.',
      uploadKeywords: 'воден знак на изображение, добавяне на воден знак, текстов воден знак',
      workspaceTitle: 'Воден Знак на Изображение — photremium.com',
      workspaceDesc: 'Добавяйте водни знаци към изображения безплатно онлайн.',
      workspaceKeywords: 'воден знак, добавяне на воден знак',
    },
    title: 'Воден Знак на Изображение',
    desc: 'Добавяйте текстови или лого водни знаци към изображения. Персонализирайте шрифт, непрозрачност, размер и позиция.',
    toWatermark: 'за воден знак',
    watermarkTools: 'Инструменти за Воден Знак',
    addText: 'Добави Текст',
    addImage: 'Добави Изображение',
    layersN: 'Слоеве ({n})',
    noLayers: 'Все още няма добавени слоеве',
    textLayer: 'Текстов Слой',
    imageLayer: 'Слой Изображение',
    watermarkDownloadAll: 'Добави Знак и Изтегли Всички',
    watermarkDownload: 'Добави Знак и Изтегли',
    nextImage: 'Следващо Изображение',    selectToEdit: 'Изберете изображение или текст, за да започнете редакцията',    bold: 'Удебелен',
    italic: 'Курсив',
    underline: 'Подчертан',
    bgColor: 'Цвят на Фона',
    textColor: 'Цвят на Текста',
    alignLeft: 'Наляво',
    alignCenter: 'По Средата',
    alignRight: 'Надясно',
    opacity: 'Непрозрачност',
    stroke: 'Контур',
    strokeWidth: 'Ширина на Контура',
    strokeColor: 'Цвят на Контура',
    tileRepeat: 'Плочки/Повторение',
    tilePattern: 'Модел на Плочки',
    spacing: 'Разстояние',
    snapToCenter: 'Прикрепи към Центъра',
    duplicate: 'Дублирай',
    delete: 'Изтрий',
    flipHorizontal: 'Обърни Хоризонтално',
    flipVertical: 'Обърни Вертикално',
    rotateLeft: 'Завърти наляво',
    rotateRight: 'Завърти надясно',
    cornerRadius: 'Радиус на Ъгъла',
    borderStroke: 'Рамка/Контур',
    borderWidth: 'Ширина на Рамката',
    color: 'Цвят',
    style: 'Стил',
    hide: 'Скрий',
    show: 'Покажи',
    lock: 'Заключи',
    unlock: 'Отключи',
    solid: 'Плътна',
    dashed: 'Пунктирана',
    dotted: 'С точки',
    double: 'Двойна',
    tileSingle: 'Единична',
    tile2x2: 'Мрежа 2×2',
    tile3x3: 'Мрежа 3×3',
    removeAllConfirm: 'Да изтрия ли всички изображения и водни знаци?',
    dimMismatch: 'Качените изображения имат различни размери. За най-добри резултати качете изображения с еднаква разделителна способност.',
    clearBackground: 'Изчисти Фона',
    typeHere: 'Въведете тук...',
    linkCorners: 'Свържи Ъглите',
    separateCorners: 'Раздели Ъглите',
    blog: {
      tocTitle: 'Съдържание',
      sections: [
        {
          id: 'wm-blog-intro',
          tocLabel: 'Обзор на инструмента',
          title: 'Как да добавите воден знак към изображенията си онлайн — пълното ръководство за инструмента за воден знак на Photremium',
          paragraphs: [
            'Току-що завършихте обработката на красива снимка. Може би това е продуктова снимка за вашия магазин, портрет от клиентска сесия или дигитално произведение, върху което сте работили с часове. И сега идва въпросът, пред който рано или късно се изправя всеки творец: как да я защитите преди да я споделите?',
            'Отговорът, до който стигат повечето професионалисти, е воден знак — и с основание. Правилно поставеният воден знак действа като постоянен подпис върху вашата работа, прави я разпознаваема, брандирана и значително по-трудна за кражба.',
            'Проблемът за повечето хора е следният: онлайн инструментите са или тромави, или скрити зад абонаменти, или поставят толкова тежък воден знак, че развалят изображението.',
            'Инструментът за водни знаци на Photremium е създаден да реши точно това. Той работи изцяло в браузъра, безплатен е, не изисква акаунт и не качва файловете ви на сървър. Всичко остава локално, всичко е бързо, а нивото на контрол е сравнимо с професионални десктоп приложения. В това ръководство ще ви покажем как точно работи, за кого е предназначен и как да постигате най-добри резултати — всеки път.',
          ],
        },
        {
          id: 'wm-blog-what-is',
          tocLabel: 'Какво е воден знак',
          title: 'Какво е воден знак и защо е важен?',
          paragraphs: [
            'Преди да навлезем в инструмента, важно е да разберем какво прави водният знак и защо толкова много фотографи, дизайнери и създатели на съдържание го считат за задължителен.',
            'Водният знак е видима наслагване върху изображение — обикновено текст, лого или знак за авторско право — която идентифицира създателя или собственика на съдържанието. За разлика от метаданните (които са скрити в файла и могат да бъдат премахнати за секунди), водният знак е визуално вграден в самото изображение. Не можете просто да щракнете с десен бутон и да го премахнете, без да влошите качеството.',
          ],
          subSections: [
            {
              title: 'Защо творците използват водни знаци',
              paragraphs: [
                'Практическите причини да поставите воден знак се свеждат до три основни цели.',
              ],
              bullets: [
                'Идентификация на собствеността. Когато работата ви се споделя в социални мрежи, Pinterest или блогове, оригиналната атрибуция често се губи. Водният знак гарантира, че името или брандът ви пътува заедно с изображението.',
                'Възпиране на кражба. Повечето хора, които крадат изображения, търсят най-лесния път. Професионален воден знак, добре позициониран и леко прозрачен, изпраща ясен сигнал: това изображение е на някого, който се грижи за работата си.',
                'Защита на клиентско портфолио. Фотографи, които споделят предварителни версии с клиенти преди плащане, често използват водни знаци, за да предотвратят неправомерна употреба. Дискретният воден знак постига това без да разсейва оценката на кадъра.',
              ],
            },
            {
              title: 'Кой трябва да използва водни знаци',
              paragraphs: [
                'Ако попадате в някоя от следните категории, водният знак преди споделяне не е опция — той е необходимост:',
              ],
              bullets: [
                'Фрийланс фотографи, които споделят галерии с клиенти',
                'Графични дизайнери, които публикуват портфолио',
                'Продавачи в e-commerce, показващи продуктови снимки преди лицензиране',
                'Дигитални артисти, които споделят в социални платформи',
                'Блогъри и създатели на съдържание, чиито изображения се използват повторно',
                'Автори на стокови снимки, които изграждат разпознаваем бранд',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-workspace',
          tocLabel: 'Панели на работното място',
          title: 'Вътре в инструмента за водни знаци на Photremium: работно място с три панели за реални процеси',
          paragraphs: [
            'Това, което отличава инструмента на Photremium от базовите уотърмаркери, е дизайнът на работното място. Вместо прост подход „въведи текст, избери позиция, готово“, инструментът предлага оформление с три панела, подобно на професионален софтуер — но работи изцяло в браузъра без инсталация.',
          ],
          subSections: [
            {
              title: 'Левият панел с платното',
              paragraphs: [
                'Панелът с платното заема най-голямата част от екрана и показва изображението с приложен воден знак в реално време. Всяка промяна — прозрачност, позиция на текст, размер на лого — се отразява моментално. Няма бутон „преглед“. Това, което виждате, е това, което получавате.',
                'Платното включва и вграден инструмент за увеличение, който позволява прецизно подравняване. Функцията за автоматично напасване изчислява най-добрия мащаб според размера на екрана, така че дори големи изображения се показват удобно. При плъзгане близо до центъра се появяват динамични водачи, които „снапват“ водния знак точно по средата — усещане, което обикновено получавате в Photoshop.',
              ],
            },
            {
              title: 'Десният панел с настройки',
              paragraphs: [
                'Десният панел е командният център. Тук управлявате слоевете, настройвате вида им и стартирате експорта. На десктоп той е фиксиран отдясно. На мобилни устройства се показва като долен панел, отварян с плаващ бутон, така че не покрива платното.',
                'Вътре ще намерите мениджър на слоеве, който изброява всеки воден знак. Всеки слой показва типа (текст или изображение), текущо име или съдържание и три бързи бутона: видимост (икона око), заключване на позицията и изтриване.',
              ],
            },
            {
              title: 'Лява лента с миниатюри (режим с много изображения)',
              paragraphs: [
                'Когато работите с множество изображения — например продуктови снимки или цяла фотосесия — вляво се появява вертикална лента с миниатюри. Това е опашката с файлове. Клик върху миниатюра сменя активното изображение на платното мигновено, без да губите настройките на слоя.',
                'Лентата показва и размера на файла в KB или MB, както и формата (JPG, PNG, WEBP), за да знаете какво обработвате с един поглед.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-steps',
          tocLabel: 'Стъпка по стъпка',
          title: 'Стъпка по стъпка: как да добавите воден знак към изображение в Photremium',
          paragraphs: [
            'Това ръководство следва начина, по който инструментът реално работи — от drag-and-drop качването до рендера върху Canvas преди изтегляне.',
          ],
          steps: [
            {
              heading: 'Стъпка 1 — Качете изображението/та',
              paragraphsBefore: [
                'Отидете на photremium.com/watermark-image. Ще видите чиста зона за качване в центъра на страницата.',
                'Имате три начина да заредите изображение:',
              ],
              bullets: [
                'Drag and drop. Плъзнете един или повече файлове в зоната. Инструментът приема JPEG, PNG, WEBP и други стандартни формати. При влачене се появява лилава рамка с подсказка „Drop images to add for watermarking“.',
                'Click to browse. Кликнете „Choose Files“, за да отворите файловия мениджър. Можете да изберете много файлове с Ctrl+Click (Windows) или Cmd+Click (Mac).',
                'Paste from clipboard. Ако сте копирали изображение в клипборда — от скрийншот, приложение или браузър — натиснете Ctrl+V (Cmd+V на Mac). Това работи и при вече заредени изображения.',
              ],
              paragraphsAfter: [
                'След като първото изображение се зареди, интерфейсът преминава към редактора с три панела, а изображението се показва в автоматично изчислен мащаб.',
              ],
            },
            {
              heading: 'Стъпка 2 — Добавете текстов воден знак',
              paragraphsBefore: [
                'Натиснете лилавия бутон „Add Text“ в десния панел. На платното се появява нов текстов слой с „Type here...“ предварително избран.',
                'Можете да започнете да пишете веднага. Текстът се визуализира в бяло Arial с размер, съобразен с изображението. В горната лента за инструменти можете да настройвате:',
              ],
              bullets: [
                'Font family — избор от 12 вградени шрифта, включително Arial, Georgia, Impact, Brush Script MT, Comic Sans MS и др.',
                'Font size — въведете конкретна стойност или използвайте контроли за увеличение',
                'Bold, italic, underline — комбинации от стилове',
                'Text color — избор на цвят чрез пипета',
                'Background color — цветен фон зад текста за етикет/значка',
                'Stroke (outline) — контур за добра четимост върху светли и тъмни фонове',
                'Opacity — от 0% до 100%; най-често 30–60%',
                'Alignment — ляво, център, дясно подравняване',
                'Rotation — въртене с магнитни точки при 0°, 90°, 180°, 270°',
              ],
              paragraphsAfter: [
                'За преместване — плъзнете текста. За прецизно позициониране използвайте стрелките на клавиатурата (Shift за 10 пиксела). За промяна на размера — дръпнете някоя от 8-те дръжки.',
              ],
            },
            {
              heading: 'Стъпка 3 — Добавете изображение (лого) като воден знак',
              paragraphsBefore: [
                'Ако искате да използвате лого или подпис, натиснете „Add Image“ в десния панел и изберете файл. Инструментът автоматично го оразмерява на около 30% от ширината на платното и го центрира.',
                'След това можете да го местите, да променяте размера от ъглите (със запазени пропорции) и да го завъртате с дръжката над слоя. За изображенията има допълнителни контроли:',
              ],
              bullets: [
                'Opacity — както при текстовете, идеално за PNG лога',
                'Flip horizontal / Flip vertical — огледално обръщане',
                'Border width, border color, border style — рамка около логото',
                'Border radius — заобляне на ъглите, общо или поотделно',
                'Rotation — плавно въртене като при текстовите слоеве',
              ],
            },
            {
              heading: 'Стъпка 4 — Настройте тила (по избор)',
              paragraphsBefore: [
                'Една от най-силните функции е тила — повторение на водния знак като мрежа по цялото изображение. Това е полезно, ако искате изображението да е трудно за повторна употреба.',
                'С избран слой потърсете Tile опцията. Можете да изберете:',
              ],
              bullets: [
                'None — единично позициониране (по подразбиране)',
                'Grid 2×2 — повторение в 2x2 мрежа',
                'Grid 3×3 — повторение в 3x3 мрежа',
              ],
              paragraphsAfter: [
                'Можете да регулирате и разстоянието между копията. На платното се показват призрачни копия за визуализация.',
              ],
            },
            {
              heading: 'Стъпка 5 — Използвайте мениджъра на слоеве',
              paragraphsBefore: [
                'Можете да добавяте неограничен брой слоеве — текст и изображения. Мениджърът в десния панел ги показва всички. Можете да:',
              ],
              bullets: [
                'Показвате/скривате слоеве с иконата око',
                'Заключвате слой, за да не го преместите случайно',
                'Изтривате слой',
              ],
              paragraphsAfter: [
                'Клик върху даден слой в списъка го избира на платното, така че лесно да преминавате между слоевете.',
              ],
            },
            {
              heading: 'Стъпка 6 — Превключвайте между множество изображения',
              paragraphsBefore: [
                'Ако сте качили повече от едно изображение, използвайте лентата с миниатюри вляво. Всички ваши слоеве се прилагат върху всяко изображение при експортиране.',
                'Инструментът проверява и за различни резолюции. Ако има разлика над 5%, се показва предупреждение. Позицията се изчислява пропорционално, така че водният знак да изглежда правилно на всяко изображение.',
              ],
            },
            {
              heading: 'Стъпка 7 — Изберете начин на изтегляне',
              paragraphsBefore: [
                'За единично изображение натиснете „Download“ под платното. Името на файла се запазва с добавено „-watermarked“. JPEG се изнася с качество 0.95, а PNG — без загуби.',
                'За множество изображения имате два режима в десния панел:',
              ],
              bullets: [
                'ZIP — всички водни знаци се пакетират в един ZIP файл',
                'Separate — всяко изображение се изтегля поотделно с кратка пауза',
              ],
            },
            {
              heading: 'Стъпка 8 — Изтеглете и проверете',
              paragraphsBefore: [
                'След натискане на изтегляне инструментът рендерира всеки файл на скрит Canvas в пълна резолюция — не на мащабирания преглед. Така получавате оригинални размери с правилно позициониран воден знак. Отворете файла и увеличете, за да проверите резултата.',
                'Ако нещо не изглежда правилно, просто се върнете в работното място, коригирайте и изтеглете отново.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-tips',
          tocLabel: 'Про съвети',
          title: 'Про съвети за най-добри резултати',
          bullets: [
            'Използвайте полу-прозрачно PNG лого за максимална професионалност. Лого с прозрачност 40–50% изглежда далеч по-стилно от плътен текст.',
            'Поставяйте водния знак там, където изрязването би разрушило стойността. Долният десен ъгъл е най-често срещан — и най-лесно се изрязва. За по-добра защита го поставете върху ключова зона на изображението. Диагоналният тила е още по-труден за премахване.',
            'Използвайте заключване, когато работите с няколко слоя. Така предотвратявате случайно местене.',
            'Тествайте върху светли и тъмни части. Белият текст изчезва върху светло небе, но е четим върху сянка. Добавете контур или фон за добра четимост.',
            'Клавишните комбинации пестят време. Стрелките местят слоя с 1 пиксел, Shift+Arrow — с 10 пиксела. Delete изтрива слоя незабавно.',
          ],
        },
        {
          id: 'wm-blog-privacy',
          tocLabel: 'Поверителност',
          title: 'Поверителност и сигурност: защо обработката в браузъра е важна',
          paragraphs: [
            'Едно от основните притеснения при онлайн инструменти е къде отиват изображенията. При сървърните решения снимката се качва, обработва и се връща обратно. Това означава, че вашите непубликувани работи преминават през чужда инфраструктура.',
            'Инструментът на Photremium обработва всичко локално в браузъра. Файловете се зареждат в паметта чрез File API и не се изпращат в интернет. Рендерирането се извършва чрез HTML5 Canvas в самия браузър. При затваряне на страницата или „Start Over“, данните се освобождават. Нищо не се съхранява извън вашето устройство.',
          ],
        },
        {
          id: 'wm-blog-summary',
          tocLabel: 'Финално обобщение',
          title: 'Защо инструментът за воден знак на Photremium заслужава място във вашия работен процес',
          paragraphs: [
            'Има десетки инструменти за водни знаци онлайн. Разликата между инструмент, който си струва да запомните, и такъв, който забравяте, обикновено е комбинация от скорост, контрол и доверие.',
            'Скоростта е важна, защото водният знак не трябва да забавя процеса ви. Photremium се зарежда мигновено, обработва локално и експортира в пълна резолюция за секунди — дори при големи серии. Няма изчакване на сървъри, опашки или забавяне според трафика.',
            'Контролът е важен, защото лошият воден знак е по-лош от липса на такъв — изглежда непрофесионално. Слоевете, контролите по свойства, живият преглед и клавишните комбинации дават ниво на контрол, сравнимо с настолен софтуер.',
            'Доверието е важно, защото непубликуваната работа е ценна. Когато знаете, че изображенията ви не напускат устройството, можете спокойно да маркирате клиентски снимки, продуктови кадри или чувствителни материали.',
            'Независимо дали добавяте бърз знак към една снимка или обработвате 200 изображения за клиент, инструментът на Photremium ви дава всичко необходимо — напълно безплатно, напълно локално, с достатъчна гъвкавост, за да изглежда знакът естествено върху изображението.',
            'Отидете на photremium.com/watermark-image и опитайте. Първата ви маркирана снимка е на буквално 30 секунди разстояние.',
            'Photremium предлага цял пакет от браузърни инструменти за изображения. Всички работят локално — вашите файлове остават на устройството ви.',
          ],
        },
      ],
    },
  },

  qrGenerator: {
    seo: {
      inputTitle: 'Генератор на QR Кодове — Генерирайте и Персонализирайте Безплатно | photremium.com',
      inputDesc: 'Генерирайте персонализирани QR кодове за URL, текст, WiFi, контакти, имейл и Google Maps.',
      inputKeywords: 'генератор qr кодове, създай qr код, персонализиран qr код',
      customizeTitle: 'Персонализиране на QR Код — photremium.com',
      customizeDesc: 'Персонализирайте стила, цветовете, рамката и логото на QR кода. Изтеглете като PNG, JPG, SVG, WEBP или PDF.',
      customizeKeywords: 'персонализиране qr код, стил qr код',
    },
    title: 'Генератор на QR Кодове',
    desc: 'Генерирайте, персонализирайте и изтегляйте QR кодове за URL, текст, WiFi, контакти, имейл и карти.',
    generate: 'Генерирай',
    scanQrCode: 'Сканирай QR Код',
    tabUrl: 'Връзка / URL',
    tabText: 'Текст',
    tabWifi: 'WiFi',
    tabContact: 'Контакт',
    tabEmail: 'Gmail',
    tabMaps: 'Google Maps',
    enterUrl: 'Въведи URL',
    enterText: 'Въведи текст',
    networkName: 'Име на мрежата (SSID)',
    password: 'Парола',
    encryption: 'Криптиране',
    hiddenNetwork: 'Скрита Мрежа',
    contactName: 'Име на контакт (по желание)',
    phoneNumber: 'Телефонен номер',
    emailAddress: 'Имейл адрес',
    subject: 'Тема (по желание)',
    body: 'Тяло на съобщението (по желание)',
    searchLocation: 'Търси местоположение',
    urlPlaceholder: 'https://example.com',
    textPlaceholder: 'Въведете текст тук…',
    wifiNamePlaceholder: 'Моят WiFi',
    passwordPlaceholder: 'парола',
    contactPlaceholder: 'Иван Иванов',
    phonePlaceholder: '+359 88 123 4567',
    emailPlaceholder: 'example@gmail.com',
    subjectPlaceholder: 'тема',
    bodyPlaceholder: 'тяло на имейла…',
    locationPlaceholder: 'Търсете град, адрес, място…',
    wpaWpa2: 'WPA / WPA2',
    wep: 'WEP',
    none: 'Няма',
    characters: 'символа',
    generateCustomize: 'Генерирай и Персонализирай',
    editQrData: 'Редактирай QR Данни',
    styleShape: 'Стил и Форма',
    colorTab: 'Цветове',
    framesTab: 'Рамки',
    logoTab: 'Лого',
    templatesTab: 'Шаблони',
    fileFormatTab: 'Файлов Формат',
    fgColor: 'Цвят на Предния План',
    bgColor: 'Цвят на Фона',
    enableGradient: 'Активирай Градиент',
    gradientType: 'Тип Градиент',
    linear: 'Линеен',
    radial: 'Радиален',
    selectFrame: 'Избери Рамка',
    selectLogo: 'Избери Лого',
    uploadCustomLogo: 'или качете собствено лого',
    uploadImage: 'Качи Изображение',
    downloadFormat: 'Формат за Изтегляне',
    preview: 'Преглед',
    downloadFormatBtn: 'Изтегли {format}',
    pngDesc: 'Без загуби, поддържа прозрачност',
    jpgDesc: 'Популярен/универсален файлов формат',
    webpDesc: 'Модерен формат, най-добро качество/размер',
    svgDesc: 'Мащабируема векторна графика',
    pdfDesc: 'Документ готов за печат',
    lat: 'Ширина:',
    lng: 'Дължина:',
    qrCode: 'QR Код',
    scanMe: 'Сканирай Ме',
    scanHere: 'Сканирай Тук',
    blog: {
      card1: {
        title: '1. Какво е QR код?',
        intro1: 'Пълното име на QR код е "Quick Response code" (код за бърз отговор). Тъй като информацията, съхранена в него, се декодира много бързо, се нарича Quick Response (QR) код.',
        intro2: 'QR кодът е двуизмерен цифров код, който могат да четат само машини. Данните в него не могат да се четат от човек. Той съдържа блокове за съхранение на информация като текст, телефонни номера, връзки и локации на Google Maps и т.н.',
        inventionTitle: 'Как е измислен QR кодът:',
        inventionText: 'QR кодът е измислен през 1994 г. Масахиро Хара и неговият екип работеха в японска компания, наречена Denso Wave, която произвеждаше автомобилни части за Toyota. Те искали код, който съхранява много повече информация от обикновен баркод, и така измислиха QR кода.',
        keyFeaturesTitle: 'Ключови функции на QR кода',
        keyFeatures: [
          {
            title: 'Как работи QR',
            text: 'Въвеждате текста или връзката, за да генерирате QR код. QR генераторът прави квадратни кутии според информацията. Всяка кутия представлява един бит, а всеки бит съхранява един символ.',
          },
          {
            title: 'Структура на QR кода',
            text: 'QR кодът съдържа три големи квадратни кутии, за да идентифицира ориентацията на QR кода, и една малка квадратна кутия за съхранение на битовете (информацията).',
          },
          {
            title: 'Капацитет на данни на QR кода',
            text: 'Обикновено QR кодът съхранява повече информация от баркода. QR кодът е просто усъвършенствана версия на баркода. По сути е двуизмерен баркод. QR кодът съхранява почти 200 символа. Може да съхранява и 400 символа, но може да бъде трудно сканиране. Съхранението на повече от 400 символа може да води до много сложен QR код, който почти не може да се сканира.',
          },
          {
            title: 'Откритие на грешки в QR кодовете',
            text: 'QR кодът остава сканируем, дори ако някоя информация е надраскана или някои битове са променени. QR кодът използва техника на Reed-Solomon за откритие и поправяне на грешките.',
          },
        ],
        errorTitle: 'Ниво на корекция на грешки на QR кода:',
        errorIntro: 'Различни техники за откритие и корекция на грешки се използват в различни случаи, както е описано по-долу:',
        errorHeaders: {
          level: 'Ниво',
          recovery: 'Възможност за поправка',
          bestUse: 'Най-добър случай на употреба',
        },
        errorRows: [
          {
            level: 'Ниско (L)',
            recovery: '~7%',
            useCases: [
              'Тази техника се използва, когато QR кодът се показва на цифрови екрани, уебсайтове или в чиста среда.',
              'Когато QR код е генериран за малка информация като Gmail, телефонен номер или малък текст.',
            ],
          },
          {
            level: 'Средно (M)',
            recovery: '~15%',
            useCases: [
              'За листовки и плакати, които се инсталират в чиста среда, и когато риск от повреда е минимален.',
            ],
          },
          {
            level: 'Квадратур (Q)',
            recovery: '~25%',
            useCases: [
              'Когато QR кодът трябва да се инсталира в суровата среда, като في фабрика/открито.',
              'Също и когато малко лого е необходимо в центъра, то покрива някои битове. Затова тази техника е необходима.',
            ],
          },
          {
            level: 'Висока (H)',
            recovery: '~30%',
            useCases: [
              'Използва се, когато е възможна тежка повреда на QR кода.',
              'Когато големи логота покриват центъра на QR кода.',
              'Също и когато е необходим тежък дизайн за QR кода.',
            ],
          },
        ],
      },
      card2: {
        title: '2. Защо да изберете нашия генератор на QR кодове?',
        intro: 'Нашият генератор на QR кодове прави генериране на QR кодове невероятно бързо, сигурно и лесно. Можете да персонализирате кода си, като го направите по-напреднал, професионален и съответстващ на вашата бизнес тема. Всички персонализации, от оцветяване на QR кода до инсталация на лого в QR кода, се предлагат безплатно завинаги.',
        strengths: [
          {
            title: 'Професионална персонализация:',
            text: 'Можете да генерирате и персонализирате толкова много QR кодове, колкото имате нужда, без никакви разходи. Всички функции са напълно безплатни. Можете да прилагате градиентни цветове, различни форми за квадратни кутии, персонални логота и много други функции.',
          },
          {
            title: 'Поддръжка на множество формати:',
            text: 'Нашият генератор на QR кодове предлага множество формати за изтегляне за ваше удобство. Трябва само да изберете предпочитания формат преди изтегляне. В момента предлагаме ces формати:',
          },
          {
            title: 'Предварително направени шаблони:',
            text: 'Можете да използвате предварително направени градиентни цветове и рамки, които правят QR кода професионален.',
          },
          {
            title: 'Поддръжка на персонално лого:',
            text: 'Можете също да качите персоналното лого на вашия бранд, което се приспособява автоматично в центъра на QR кода. Можете също да изберете лого от вградена библиотека на логята, където се предоставят повече от 30 логота.',
          },
          {
            title: 'Live Preview:',
            text: 'Докато персонализирате, можете да наблюдавате всички промени в панела за live preview. Тези промени в панела за preview са в реално време и се променят динамично.',
          },
          {
            title: 'Индикатор за сканиране:',
            text: 'Докато избирате цветове, правилни предупреждения и индикатори ви насочват, ако изберете цветове, които са трудни за сканиране.',
          },
        ],
        formatHeaders: {
          srNo: 'Пор. №',
          formats: 'Формати',
          description: 'Описание',
        },
        formatRows: [
          { no: '1', format: 'PNG', description: 'Без загуби, поддержка на прозрачност' },
          { no: '2', format: 'JPG', description: 'Популярен, универсален файлов формат' },
          { no: '3', format: 'WEBP', description: 'Модерен, най-добро качество/размер' },
          { no: '4', format: 'SVG', description: 'Мащабируема векторна графика' },
          { no: '5', format: 'PDF', description: 'Документ готов за печат' },
        ],
      },
      card3: {
        title: '3. Пътеводител стъпка по стъпка:',
        step1Intro: 'Първо изберете категорията на QR кода, който искате да генерирате. Или генерирате QR код за контакт, карта, връзка или текст. В момента нашият генератор на QR кодове предлага тези категории:',
        categories: ['Връзка / URL', 'Текст', 'WiFi', 'Контакт', 'Gmail', 'Google Maps'],
        step2: 'След избиране на категорията, поставете информацията си в текстовото поле съответно.',
        step3Intro: 'След това щракнете на "Генерирай и персонализирай", за да отворите панела за персонализирање. В панела за персонализирање ще видите подменю с következő опции:',
        options: [
          {
            title: 'Стил и форма:',
            text: 'В този раздел можете да промените формите на квадратните кутии в множество стилове, като закръглени ъгли, точки, хоризонтални пръти, вертикални пръти, малки квадрати и много други.',
          },
          {
            title: 'Цвят:',
            text: 'Можете да изберете персонални цветове на фон и преден план в този раздел. За да направите QR кода си в градиентни цветове, имате возможност да активирате градиент, който ви позволява да прилагате всеки градиентен цвят от вградена библиотека или да направите собствен градиентен цвят лесно. Можете също да промените ъгъла за линеен градиент. Поддържа се и радиален градиент. Можете да добавите няколко цвята, за да направите професионален градиентен ефект.',
          },
          {
            title: 'Рамки:',
            text: 'Тук можете да изберете перфектна рамка за вашия QR код. Всички рамки автоматично се подравняват с кода. Трябва само да изберете рамка от вградена библиотека.',
          },
          {
            title: 'Лого:',
            text: 'След избиране на рамка, можете да изберете лого, което се автоматично прилага в центъра на QR кода. Поддържа се и качване на персонално лого на вашия бранд.',
          },
          {
            title: 'Шаблони:',
            text: 'Ако не искате да избирате стил, форма, цвят и рамка отделно, можете да прилагате готови шаблони на QR кода. За ваше удобство се предоставят множество премиум шаблони, които са безплатни завинаги.',
          },
          {
            title: 'Файлов формат:',
            text: 'Накрай трябва да изберете типа файл, в който искате да изтеглите QR кода. Поддържат се няколко често срещани формата, включително PNG, WEBP, SVG и PDF и т.н.',
          },
          {
            title: 'Редактирай QR данни:',
            text: 'Можете също да редактирате QR данните си без никаква загуба на избраните персонализации.',
          },
        ],
        finalStep: 'След това просто щракнете на бутона за изтегляне, и QR кодът точно според вашите персонализации и в избрания формат ще бъде изтеглен незабавно без никакви разходи.',
      },
      card4: {
        title: '4. Преимущества:',
        intro: 'QR кодът свързва физическия свят с дигиталния опит. Това е най-бързия начин да споделите връзки, контакт или вашето местоположение. Трябва само да сканирате този QR код, за да получите информацията незабавно. Затова е много популярен в бизнеса и дигиталния свят, защото е времеускоклюючий и дълбоко целеустремен.',
        benefits: [
          {
            title: 'Целотрайна поддръжка:',
            text: 'QR кодовете работят завинаги без никаква дата на изтичане. Те ви дават информацията, съхранена незабавно, когато я сканирате. Тъй като съхранява твердо кодирани дигитални инструкции, никога не теглят своята информация.',
          },
          {
            title: 'Поддръжка без интернет:',
            text: 'Можете да сканирате QR кода дори ако сте офлайн. Камерата на вашия мобилен телефон декодира шаблоните на QR кода и ви дава информацията, съхранена в него.',
          },
          {
            title: 'Нулева цена:',
            text: 'Тъй като тези кодове не изискват никакво пренасочване на сървър или ресурси, това е безплатно завинаги.',
          },
        ],
      },
    },
  },

  qrScanner: {
    seo: {
      title: 'Скенер на QR Кодове — Сканирайте QR Кодове с Камера или Изображение | photremium.com',
      desc: 'Незабавно сканирайте QR кодове с камера или качете изображение. Засича URL, текст, WiFi, контакти и др.',
      keywords: 'скенер qr кодове, сканиране qr код, четец qr, qr код онлайн',
    },
    title: 'Скенер на QR Кодове',
    desc: 'Незабавно сканирайте QR кодове с камера или качете изображение. Бързо и сигурно.',
    generateQrCode: 'Генерирай QR Код',
    scan: 'Сканирай',
    cameraScanner: 'Скенер с Камера',
    uploadImage: 'Качи Изображение',
    pointCamera: 'Насочете камерата към QR кода',
    startCamera: 'Стартирай Камера',
    loading: 'Зареждане…',
    dropQrImage: 'Пуснете изображение с QR код тук',
    toScan: 'за сканиране',
    supportedFormats: 'Поддържа JPG, PNG, GIF, WEBP',
    ctrlVPaste: 'Поставете с Ctrl+V',
    scanFromGallery: 'Сканирай от Галерия',
    instantScanning: 'Моментално Сканиране',
    instantScanningDesc: 'Откриване на QR кодове в реално време от камера или качени изображения',
    private100: '100% Поверително',
    private100Desc: 'Цялата обработка се извършва в браузъра ви. Нищо не се качва',
    multiFormat: 'Много Формати',
    multiFormatDesc: 'Открива URL, текст, WiFi, контакти, имейл, телефон и още',
    accessingCamera: 'Достъп до камерата…',
    cameraDenied: 'Достъпът до камерата е отказан. Разрешете достъп до камерата и опитайте отново.',
    noCamera: 'Не е намерена камера на това устройство.',
    cameraError: 'Не може да се осъществи достъп до камерата. Опитайте отново.',
    videoError: 'Видео възпроизвеждането не можа да стартира.',
    switchError: 'Камерата не можа да бъде сменена.',
    tryAgain: 'Опитай Отново',
    switchCamera: 'Смени Камера',
    stop: 'Спри',
    noQrFound: 'Не е Намерен QR Код',
    couldNotRead: 'Не може да се прочете изображението',
    scannerFailed: 'Неуспешно зареждане на скенера',
    noQrFoundDesc: 'В изображението не е засечен QR код. Опитайте друго изображение или използвайте скенера с камера.',
    qrScanned: 'QR Кодът е Сканиран!',
    openLink: 'Отвори Връзка',
    copied: 'Копирано!',
    copy: 'Копирай',
    share: 'Сподели',
    scanAgain: 'Сканирай Отново',
    network: 'Мрежа',
    password: 'Парола',
    security: 'Сигурност',
    unknown: 'Неизвестно',
    typeText: 'Текст',
    typeUrl: 'URL',
    typeWifi: 'WiFi Мрежа',
    typeContact: 'Карта за Контакт',
    typeEmail: 'Имейл',
    typePhone: 'Телефонен Номер',
    typeSms: 'SMS',
    typeLocation: 'Местоположение',
    blog: {
      tocTitle: 'Съдържание',
      sections: [
        {
          id: 'why-use-qr-code-scanner',
          title: '1. Защо да използвате скенер за QR кодове?',
          paragraphs: [
            'Скенерът за QR кодове по същество е мобилна камера, която декодира информацията, съхранена в QR кода. Трябва само да насочите камерата към QR кода и независимо от ориентацията, той ще разчете шаблоните, ще открие грешки, ще ги коригира при нужда и ще покаже информацията в кода.',
          ],
          listTitle: 'Видове скенери за QR кодове:',
          bullets: [
            'Уеб базиран скенер за QR кодове: Можете да сканирате QR код чрез онлайн скенери, поддържани от браузъра ви. Достъпвате информацията чрез камера или чрез качване на изображение. За автоматично пренасочване и други разширени функции можете да посетите https://photremium.com.',
            'Мобилни камери: Някои съвременни телефони имат вграден скенер за QR кодове в стандартното приложение за камера. Те извличат и декодират информацията само чрез сканиране с камера.',
            'Приложения: Има приложения, създадени специално за сканиране на QR кодове. За разширено пренасочване и много други функции можете да използвате безплатно инструмента чрез https://photremium.com.',
            'Хардуерни устройства: Има и хардуерни устройства, създадени за сканиране на QR кодове. Те се използват широко в големи търговски центрове за таксуване на продукти.',
          ],
        },
        {
          id: 'why-choose-our-qr-code-scanner',
          title: '2. Защо да изберете нашия скенер за QR кодове?',
          paragraphs: [
            'Можете да използвате множество разширени функции, от пренасочване до копиране на съдържанието, декодирано от QR кода. В нашия скенер ще откриете и много други полезни възможности:',
          ],
          bullets: [
            'Висока скорост: Нашият скенер прави декодирането на QR код изключително бързо. Нужно е само да сканирате кода и инструментът веднага показва информацията с опции за копиране на текст/линк, отваряне при открит линк или автоматично запазване при открит контакт.',
            'Без инсталация: Не е нужно да инсталирате отделно приложение, за да използвате скенера. Можете да го достъпите безплатно през браузъра си.',
            'Достъп от всяка платформа: Работи на всяко устройство. Няма притеснения за версия на ОС или други изисквания. Поддържа се на всички версии и устройства.',
            'Поддръжка на всички формати: Поддържат се всички типове данни, които могат да бъдат в QR код, включително обикновен текст, WiFi, URL, контакти, Gmail и Google Maps.',
          ],
        },
        {
          id: 'step-by-step-guide',
          title: '3. Ръководство стъпка по стъпка:',
          steps: [
            {
              heading: '1. Първо изберете метод за сканиране на QR кода. Има два начина:',
              subSteps: [
                {
                  heading: 'i. Метод с камера',
                  paragraphs: [
                    'Можете да сканирате QR кода с камерата на устройството си, независимо дали използвате лаптоп, настолен компютър или друго устройство с камера. Кликнете бутона “Стартирай Камера” и ще се покаже заявка за разрешение. Позволете достъпа, за да може сайтът да използва камерата за QR сканиране. Ако случайно сте отказали или заявката не се вижда, можете да разрешите достъпа ръчно:',
                  ],
                  notes: [
                    '➔ За Chrome (Android / Desktop):',
                    '1. Кликнете трите точки',
                    '2. Отидете в Настройки',
                    '3. (Пропуснете тази стъпка за Android) Поверителност и сигурност',
                    '4. Кликнете Настройки за сайта',
                    '5. В секцията Разрешения кликнете Камера',
                    '6. Намерете URL адреса на сайта: https://photremium.com/qr-code-scanner',
                    '7. Разрешете камерата от падащото меню.',
                    '➔ За Safari (iPhone / iOS):',
                    '1. Натиснете иконата AA или Настройки на уебсайта в адресната лента.',
                    '2. Изберете Настройки на уебсайта.',
                    '3. Натиснете Камера и изберете Разреши.',
                    '4. Ако все още е блокирано: отидете в Настройки на iPhone > Safari > Камера и задайте Попитай или Разреши.',
                  ],
                },
                {
                  heading: 'ii. Метод с галерия',
                  paragraphs: [
                    'Можете да качите изображение на QR код, за да получите информацията му. Кликнете бутона “Сканирай от Галерия” и ще се отвори файловият мениджър. След това изберете изображението с QR код. Поддържат се всички формати като jpg, .jpeg, .png, .gif, .webp, .svg, .avif, .heic, .heif, .jxl, .bmp, .ico, .tiff, .tif, .jfif, .jpe, .pjpeg, .pjp, .apng, .svgz и .xbm.',
                  ],
                },
              ],
            },
            {
              heading: '2. Когато изберете QR кода, цялата информация се показва и можете да копирате, споделите или отворите линка при откриване. Можете и да сканирате отново, ако желаете.',
            },
          ],
        },
        {
          id: 'benefits-of-qr-code-scanner',
          title: 'Ползи от скенера за QR кодове:',
          paragraphs: [
            'Скенерът за QR кодове предлага много предимства в дигиталния свят. Той прави плащанията, верификациите и достъпа до информация лесни и бързи дори в офлайн режим.',
          ],
          bullets: [
            'Моментален достъп до информация: Сканирането на QR код предоставя информация за милисекунди. Скенерът декодира шаблоните, открива грешки и ги коригира много бързо, което дава изключително бързо изживяване.',
            'Безпроблемна комуникация: В ерата на технологиите има нужда от бърза и сигурна комуникация за малки данни като банкови и продуктови детайли. Скенерът за QR кодове решава това, тъй като плащанията се правят чрез сканиране. Google също верифицира телефон чрез QR при създаване на нов акаунт на лаптоп.',
            'Е-билети: На автогари, жп гари и летища можете лесно да верифицирате билетите си без дълго чакане на опашка. Освен това на летищата се инсталират множество QR скенери, което намалява опашките и нуждата от персонал.',
            'Проверка на автентичност на продукти: Премиум брандове поставят QR код върху продуктите си. Клиентът може да сканира кода и да провери дали продуктът е оригинален.',
          ],
        },
      ],
    },
  },

  faceBlur: {
    seo: {
      uploadTitle: 'Инструмент за Замъгляване на Лице — Замъглявайте Лица в Изображения Онлайн | photremium.com',
      uploadDesc: 'Автоматично замъглявайте лица в изображения с ИИ. Изберете интензивност, форма или емоджи.',
      uploadKeywords: 'замъгляване на лице, замъгляване лица, засичане на лице, инструмент за поверителност',
      workspaceTitle: 'Инструмент за Замъгляване на Лице — photremium.com',
      workspaceDesc: 'Автоматично замъглявайте лица в изображения. 100% безплатно.',
      workspaceKeywords: 'замъгляване на лице, засичане на лице',
    },
    title: 'Замъгляване на Лице',
    desc: 'Автоматично откривайте и замъглявайте лица в изображения за защита на поверителността.',
    toBlurFaces: 'за замъгляване на лица',
    autoDetection: 'Автоматично Засичане',
    autoDetectionDesc: 'ИИ за засичане на лица мигновено открива всички лица',
    customBlur: 'Персонализирано Замъгляване',
    customBlurDesc: 'Регулирайте интензивността, формата и стила на замъгляването',
    private100: '100% Поверително',
    private100Desc: 'Цялата обработка се извършва локално в браузъра',
    blurTools: 'Инструменти за Замъгляване',
    faces: 'Лица',
    faceDetection: 'Засичане на Лице',
    detecting: 'Засичане...',
    autoDetectFaces: 'Автоматично Засичане на Лица',
    exitManualMode: 'Изход от Ръчен Режим',
    manualSelect: 'Ръчен Избор',
    nFaceRegions: 'Намерени {n} области на лице',
    noFacesDetected: 'Не са открити лица — използвайте ръчен режим',
    manualHint: 'Кликнете и плъзнете, за да нарисувате правоъгълник върху областта за замъгляване.',
    blurType: 'Тип Замъгляване',
    blur: 'Замъгляване',
    emoji: 'Емоджи',
    blurIntensity: 'Интензивност на Замъгляването',
    strength: 'Сила',
    blurShape: 'Форма на Замъгляването',
    rectangle: 'Правоъгълник',
    ellipse: 'Елипса',
    circle: 'Кръг',
    chooseEmoji: 'Избери Емоджи',
    blurRegionsN: 'Области на Замъгляване ({n})',
    faceN: 'Лице {n}',
    manualRegionN: 'Ръчна Област {n}',
    manualN: 'Ръчно {n}',
    clearAllRegions: 'Изчисти Всички Области',
    processingDots: 'Обработване...',
    downloadBlurred: 'Изтегли Замъгленото Изображение',
    downloadNImages: 'Изтегли {n} Изображения',
    downloadDialogTitle: 'Не Всички Изображения са Редактирани',
    downloadDialogText: 'Редактирани {edited} от {total}.',
    downloadAll: 'Изтегли Всички',
    removeRegion: 'Премахни Областта',
    region: 'Област',
    notAllEdited: 'Не Всички Изображения са Редактирани',
    editedXofY: 'Редактирани {edited} от {total}.',
    nextImage: 'Следващо Изображение',
  },

  faqData: {
    imageConverter: [
      { q: 'Кои формати за изображения се поддържат за конвертиране?', a: 'Поддържаме JPG, PNG, WEBP, SVG, GIF, BMP, ICO и TIFF. Можете незабавно да конвертирате между тези формати в браузъра.' },
      { q: 'Запазва ли се качеството на изображението при конвертиране?', a: 'За формати без загуби като PNG качеството се запазва напълно. За формати с компресия като JPG и WEBP използваме оптимизирани настройки за кодиране.' },
      { q: 'Има ли ограничения за размер или брой файлове?', a: 'Без строги ограничения. Можете да качите множество изображения наведнъж и да ги конвертирате групово.' },
      { q: 'Сигурни ли са данните ми? Изпращат ли се изображения до сървър?', a: 'Абсолютно. Цялата обработка се извършва в браузъра ви. Изображенията ви никога не напускат устройството.' },
      { q: 'Мога ли да конвертирам прозрачен PNG в JPG?', a: 'Да. Тъй като JPG не поддържа прозрачност, прозрачните области по подразбиране се запълват с бял фон.' },
    ],
    imageCompressor: [
      { q: 'Ще намали ли компресирането качеството на изображението?', a: 'Не, компресирането не влияе съществено на качеството, освен ако не надвишите препоръчителните граници. Индикаторите ви насочват: i. Компресия от 1% до 40%: зелен индикатор с „Добро качество“. ii. Компресия от 41% до 60%: жълт индикатор с „Нормално качество“. Този диапазон е най-препоръчителен. iii. Компресия от 61% до 100%: системата показва червено предупреждение „Лошо качество“, при което влошаването може да е видимо.' },
      { q: 'Кои формати на изображения се поддържат за компресиране?', a: 'Нашият инструмент за компресиране поддържа всички изброени формати:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'Мога ли да компресирам много изображения наведнъж?', a: 'Да, разбира се. Можете да компресирате много изображения едновременно (дори 100+), ако устройството ви го позволява. Тъй като компресирането използва ресурсите на устройството, по-мощен лаптоп, компютър или телефон ще даде по-добра производителност. При по-слабо устройство можете да компресирате на партиди, като инструментът остава безплатен.' },
      { q: 'Съхранявате ли или качвате ли нашите изображения на вашите сървъри?', a: 'Не, никога не качваме и не съхраняваме вашите изображения на сървърите си. Всички изображения се компресират локално във вашия браузър. Файловете ви никога не напускат устройството ви, така че можете спокойно да компресирате лични или поверителни снимки.' },
      { q: 'Този инструмент за компресиране на изображения безплатен ли е?', a: 'Да, нашият инструмент е напълно безплатен завинаги. Няма да ви поискаме плащане. Няма скрити такси. Всички функции, включително компресиране на много изображения, са безплатни.' },
    ],
    cropImage: [
      { q: 'Ще се влоши ли качеството на изображението след изрязване?', a: 'Не, изрязването на изображение изобщо не влияе на визуалното му качество. Изрязването само премахва нежеланата част. То никога не променя пикселите на частта, която остава след изрязване. Затова можете да изрязвате изображенията си с оригиналното качество без никакво увреждане на пикселите.' },
      { q: 'Кои формати изображения поддържа инструментът за изрязване?', a: 'Можете да изберете изображение във всеки формат, защото нашият инструмент за изрязване поддържа почти всички формати изображения. Те са изброени по-долу:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'Качват ли се моите изображения на вашия сървър?', a: 'Не, цялата обработка се извършва в локалния ви браузър. Вашите изображения никога не се качват на нашия сървър, защото те не напускат устройството ви. Така можете да изрязвате лични изображения с нашия инструмент без никакъв риск.' },
      { q: 'Мога ли да изрязвам няколко изображения едновременно?', a: 'Да, можете да изрязвате няколко изображения (дори 100+) едновременно, ако системата ви го поддържа. Понеже изрязването използва системни ресурси, при по-мощен лаптоп, компютър или телефон можете да обработвате много изображения наведнъж. Ако устройството ви е по-слабо, можете да изрязвате на партиди, защото инструментът е безплатен дори при много изображения.' },
      { q: 'Този инструмент за изрязване на изображения безплатен ли е?', a: 'Да, този инструмент за изрязване на изображения е напълно безплатен завинаги. Можете да го използвате навсякъде, по всяко време и на всяко устройство. Ще получите адаптивен дизайн за всички устройства и никога няма да бъдете помолени да платите за премиум функции. Всички функции са напълно безплатни без скрити такси.' },
    ],
    resizeImage: [
      { q: 'Мога ли да преоразмерявам няколко изображения наведнъж?', a: 'Абсолютно, нашият инструмент ви позволява да преоразмерявате много изображения едновременно. Просто качете толкова изображения, колкото устройството ви поддържа, а AI двигателят ще ги обработи наведнъж. Ако имате по-слабo устройство, преоразмерявайте на няколко партиди, за да избегнете забавяне. Процесът използва ресурси на устройството, за да няма качване към сървър и да се запази поверителността ви.' },
      { q: 'Безплатен ли е този инструмент за преоразмеряване?', a: 'Да, инструментът е безплатен завинаги. Никога няма да бъдете подканвани за платен абонамент, за да отключите премиум функции. Няма и скрити такси при изтегляне на преоразмерените изображения.' },
      { q: 'Ще намали ли преоразмеряването качеството на изображението?', a: '✅Decrease Size (downscale): Намаляването на размера на изображението няма да намали визуалното му качество. Напротив, преоразмереното изображение често изглежда по-остро от оригинала. Затова намаляването до по-малки размери няма да влоши качеството.\n❌Increase Size (upscale): Увеличаването над оригиналния размер може да повлияе на визуалното качество. Степента зависи от това колко е увеличението. Колкото повече увеличавате, толкова повече спада качеството.' },
      { q: 'Безопасен ли е този инструмент за преоразмеряване?', a: 'Да, инструментът е напълно безопасен, особено за лични и поверителни снимки, защото всички изображения се обработват локално. Нито една ваша данна не напуска устройството ви по време на обработката. Можете да преоразмерявате личните си изображения без риск.' },
      { q: 'Какви формати на изображения се поддържат?', a: 'Всички формати на изображения са поддържани. Можете да изберете изображения в следните формати:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
    ],
    removeBackground: [
      { q: 'Как работи премахването на фона?', a: 'Използваме усъвършенствани ИИ модели, работещи директно в браузъра, за да открием обекта и да го отделим от фона.' },
      { q: 'Работи ли за сложни фонове?', a: 'Да. ИИ моделът се справя с разнообразни сцени. Най-добри резултати се постигат при ясен контраст между обекта и фона.' },
      { q: 'Мога ли да премахна фона от множество изображения едновременно?', a: 'Да. Качете множество изображения и инструментът ще ги обработи последователно.' },
      { q: 'Какъв е изходният формат?', a: 'Изходът винаги е PNG файл с прозрачен фон.' },
      { q: 'Изпращат ли се изображенията ми до сървър?', a: 'Не. ИИ моделът работи изцяло в браузъра с WebAssembly.' },
    ],
    watermarkImage: [
      { q: '1. Инструментът за водни знаци на Photremium напълно ли е безплатен?', a: 'Да, инструментът за водни знаци на photremium.com/watermark-image е напълно безплатен, без акаунт и без абонамент. Можете да добавяте водни знаци на единични изображения или цели серии без платени стени, без задължителна регистрация и без лимити за изтегляне. Инструментът се финансира чрез стойността на платформата Photremium, а не чрез ограничаване на основни функции.' },
      { q: '2. Колко изображения мога да маркирам наведнъж?', a: 'Инструментът поддържа пакетно водно маркиране на множество изображения. Можете да плъзнете цяла папка в зоната за качване или да изберете десетки файлове с Ctrl+Click. Лявата лента с миниатюри показва всички файлове, а при "Watermark & Download All" инструментът рендерира всеки файл и го пакетира в ZIP (или ги изтегля като отделни файлове — по ваш избор). На практика лимитът е наличната памет на устройството ви, а не изкуствено ограничение.' },
      { q: '3. Кои формати са поддържани за вход и изход?', a: 'Входът приема формати, които File API на браузъра може да чете — обичайно JPEG, JPG, PNG, WEBP, GIF (статичен), BMP и SVG. Изходният формат се запазва като входния: ако качите PNG, получавате PNG; ако качите JPEG, получавате JPEG с качество 0.95. Това предотвратява нежелано преобразуване от беззагубен PNG към загубен JPG.' },
      { q: '4. Ще изглежда ли водният знак еднакво при различни резолюции?', a: 'Да, благодарение на пропорционалния алгоритъм за позициониране. При пакет с различни размери водният знак се създава върху референтното изображение. При експортиране двигателят изчислява относителната позиция спрямо центъра на референтното изображение и прилага същата пропорция към всяко друго изображение. Размерът се скалира пропорционално спрямо по-малкия от двата коефициента (ширина или височина), така че слоят никога да не излиза извън кадъра. Резултатът е воден знак с еднакъв относителен размер и позиция във всички изображения.' },
      { q: '5. Мога ли да използвам собствено лого или подпис като воден знак?', a: 'Да. Бутонът "Add Image" в десния панел ви позволява да качите изображение като воден знак. PNG с прозрачност е най-добрият избор — прозрачността се запазва и се вижда само логото. Можете да променяте размера чрез дръжките на ъглите (със запазване на пропорциите), да въртите, обръщате, настройвате непрозрачност и дори да добавяте рамка или заобляне на ъглите. Много потребители подготвят прозрачна версия на логото си специално за водни знаци.' },
      { q: '6. Как да направя водния знак прозрачен или полупрозрачен?', a: 'Изберете слоя на водния знак на платното. В горната лента ще видите контрол за непрозрачност с процентна стойност — можете да въведете число или да плъзнете. За дискретен професионален знак често се използват 30–50%. За по-видим знак — 70–80%. Можете бързо да сравните резултата като включвате/изключвате слоя от мениджъра на слоеве (икона око).' },
      { q: '7. Мога ли да добавя няколко водни знака към едно изображение?', a: 'Да — системата поддържа неограничен брой слоеве, всеки със собствена конфигурация. Можете да имате текстов знак в долния десен ъгъл, лого в горния ляв и плочки "SAMPLE" едновременно. Всеки слой има отделна непрозрачност, ротация, позиция, размер и стил. Мениджърът на слоеве ги организира и позволява включване/изключване без изтриване, за да тествате варианти.' },
      { q: '8. Какво прави функцията за плочки и кога да я използвам?', a: 'Плочките повтарят водния знак в мрежа по цялото изображение. Grid 2×2 поставя 4 копия, Grid 3×3 — 9 копия. Контролът за разстояние управлява празнините между повторенията. Този режим е полезен, когато искате изображението да е практически неизползваемо без разрешение — знак в ъгъла може лесно да се изреже, а пълното покритие с плочки е труднопремахваемо. Подходящо е за чернови, клиентски одобрения и предварителни версии.' },
      { q: '9. Работи ли инструментът на мобилни телефони и таблети?', a: 'Да, инструментът е напълно responsive и пригоден за мобилни устройства. Под 900px трите панели се подреждат: лентата с миниатюри става хоризонтална, платното е по средата, а настройките са долен панел, който се отваря с плаващ бутон. Всички интеракции — влачене, дръжки за размер, ротация — работят с докосване. Дръжките са по-големи на мобилни устройства (16×16 px) за по-лесно управление.' },
      { q: '10. Частни ли са данните ми? Качват ли се изображенията на сървър?', a: 'Вашите изображения не напускат устройството ви. Целият процес — зареждане, рендериране, експортиране — се изпълнява в браузъра чрез JavaScript и HTML5 Canvas API. File API създава образ в паметта, слоевете се рисуват върху офскрийн canvas, а при изтегляне данните се превръщат в Blob и се изтеглят локално. Няма мрежови заявки с данни от изображенията. Освен това има предпазител при напускане: ако излезете при заредени изображения, браузърът ще поиска потвърждение, за да избегне загуба на сесията.' },
    ],
    qrCodeGenerator: [
      { q: 'QR кодът истича ли?', a: 'Не, тези QR кодове не изтичат и гарантират поддръжка за цял живот. Тъй като съхраняват закодирани инструкции под формата на битове вътре в квадратни полета, информацията, съхранена в тях, не може да бъде изменена или премахната. Можете да достъпите информацията в кода просто чрез сканиране с която и да е камера дори след години.' },
      { q: 'Защо моят QR код не се сканира?', a: 'Вашият QR код може да не се сканира поради следните причини: i. Нисък контраст: Ако изберете подобни цветове на фона и на преден план, това влияе на видимостта на QR кода и причинява неуспех при сканиране. Но нашият инструмент ви ръководи по време на персонализиране относно нисък контраст или друг проблем, свързан със сканиране. ii. Големи данни: Ако генерирате QR код за много голям текст или данни, той става много сложен и причинява проблеми при сканиране. Валидаторът на дължина на текста ви ръководи относно оптималната дължина на текста по време на генериране на QR код. iii. Замъглено отпечатване: Уверете се, че изтегляте вашия QR код в висока разделителна способност, като PNG или SVG, които вече се поддържат от нашия инструмент.' },
      { q: 'Мога ли да добавя логото в QR кода?', a: 'Абсолютно, можете да добавите персонализиран логото или да изберете един от вградената библиотека на логота за вашия QR код. Вашият избран логото ще бъде коригиран автоматично в центъра на QR кода.' },
      { q: 'Как мога да сканирам QR кода?', a: 'Можете да сканирате QR кода, като използвате камерата на мобилния си телефон. Но за автоматично пренасочване към връзката и много други напреднали функции, можете да посетите нашия скенер на QR кодове, като използвате https://photremium.com/qr-code-scanner връзката безплатно.' },
      { q: 'Колко QR кодове мога да генерирам безплатно?', a: 'БЕЗ ОГРАНИЧЕНИЯ! можете да генерирате множество QR кодове безплатно. Всички функции, персонализиране и шаблони са безплатни завинаги за всички. Не е необходимо да се абонирате, за да се насладите на функциите на премиум.' },
      { q: 'Трябва ли ми да влезем/регистрирам, за да генерирам QR код?', a: 'Не, просто въведете текста си, генерирайте QR код и изтеглете след персонализиране. Няма необходимост от вход или регистрация, тъй като всички функции могат да бъдат достъпени напълно безплатно.' },
    ],
    qrCodeScanner: [
      { q: 'Мога ли да сканирам QR код от запазени изображения и екранни снимки?', a: '**Да**, можете да сканирате QR код от запазени изображения или екранни снимки. Нашият скенер на QR кодове https://photremium.com/qr-code-scanner ви позволява да сканирате QR код от галерията. Просто изберете изображението и ще получите цялата информация, извлечена от този QR код.' },
      { q: 'Трябва ли да инсталирам приложение за скенера на QR кодове?', a: '**Не**, нашият уеб базиран скенер ви позволява да сканирате QR код без инсталиране на приложение. Можете да използвате нашия разширен скенер безплатно на всяко устройство.' },
      { q: 'Защо скенерът не разпознава QR кода?', a: 'Вашият QR код може да не се сканира поради една от следните причини: i. Недостатъчна светлина: Сканиране при слаба светлина може да създаде проблеми. Включете фенерчето и увеличете яркостта, ако сканирате от екран. ii. Разстояние: Неподходящото разстояние също причинява проблеми. Оптималното разстояние за сканиране е около 10 инча (25 см). iii. Замърсена камера: QR кодът може да не се сканира заради замърсена леща. Почистете лещата преди сканиране. “Виждате рамка в скенера? Поставете QR кода вътре, за да се сканира успешно.”' },
      { q: 'Може ли инструментът да сканира обърнат или цветен QR код?', a: '**Да**, можете да сканирате QR код във всеки цвят или ориентация. Ако контрастът между фон и преден план е нисък, сканирането може да е по-трудно.' },
      { q: 'Безплатен ли е този инструмент?', a: '**Да**, този инструмент е напълно безплатен за използване. Можете да сканирате неограничен брой QR кодове безплатно завинаги.' },
    ],
    faceBlur: [
      { q: 'Как работи засичането на лица?', a: 'ИИ-базираният модел за засичане на лица работи директно в браузъра ви. Той идентифицира лица в изображения.' },
      { q: 'Мога ли да избера кои лица да се замъглят?', a: 'Да. След засичане всяка област на лице се маркира и можете да изберете кои лица да замъглите.' },
      { q: 'Какви стилове на замъгляване са налични?', a: 'Можете да изберете гаусово замъгляване, пикселизация или плътно цветно покритие и да регулирате интензивността.' },
      { q: 'Мога ли да замъглявам лица в множество изображения едновременно?', a: 'Да. Качете множество изображения, конфигурирайте областите за замъгляване и изтеглете всички обработени изображения.' },
      { q: 'Изпращат ли се снимките ми до отдалечени сървъри?', a: 'Не. ИИ моделът работи в браузъра ви с WebAssembly.' },
    ],
    photoEditor: [
      { q: 'Какви функции за редактиране са налични?', a: 'Регулиране на яркостта, контраста, наситеността, прилагане на филтри, добавяне на текст, наслагвания, рамки и стикери — всичко в браузъра.' },
      { q: 'Мога ли да отменям и повтарям промени?', a: 'Да. Редакторът поддържа пълна история за отмяна/повтаряне.' },
      { q: 'Кои файлови формати могат да се редактират и експортират?', a: 'Можете да редактирате JPG, PNG, WEBP и други популярни формати.' },
      { q: 'Работи ли редакторът на телефони?', a: 'Да. Редакторът е напълно отзивчив и удобен за докосване.' },
      { q: 'Съхраняват ли се изображенията ми на сървър?', a: 'Не. Цялото редактиране се извършва локално.' },
    ],
  },
};

export default bg;